
(function(){
  if (typeof CART === 'undefined') return;
  var A = {'Check(GT)':'GT Check','Matte Beige(GT)':'GT Beige','GT Matte Beige':'GT Beige'};
  CART.p.forEach(function(p){ if (A[p.c]) p.c = A[p.c]; });
  Object.keys(CART.cov || {}).forEach(function(sz){
    var m = CART.cov[sz];
    Object.keys(m).forEach(function(c){ if (A[c] && !m[A[c]]) { m[A[c]] = m[c]; delete m[c]; } });
  });
})();

;

  // 上部の保証リンクは S13 のページ内セクションへ送る。飛び先の折りたたみを開いてから見せる。
  (function(){
    function openTarget(){
      var id=location.hash.slice(1); if(!id) return;
      var d=document.getElementById(id);
      if(d && d.tagName==='DETAILS'){
        d.open=true;
        setTimeout(function(){ d.scrollIntoView({behavior:document.hidden?'auto':'smooth',block:'start'}); },0);
      }
    }
    window.addEventListener('hashchange', openTarget);
    document.addEventListener('DOMContentLoaded', openTarget);
  })();
  
;

  // Paidy公式の手順：data-amount を書き換えてから pm:refresh を呼ぶ。
  // スクリプトは head に1回だけ置く（本番レイアウト側）。26色ぶん押しても取り直さない。
  var PAIDY_SRC='https://cdn.paidy.com/promotional-messaging/general/paidy-upsell-widget.js';
  var paidyTimer=null, paidyScript=null;
  /*SALEJS:START
     ★この塊は mknew.py が特等席LP（loosy-lp7）へそのまま移す。
       2か所に同じコードを置かないため、直すのはここだけ。
       特等席LPは別原本（loosy-tokuto.release.html）なので、
       呼び出し側だけを mknew.py の EDITS で当てている。 */
  /* ── セール表記（通常価格・オフ率）────────────────────────────
     ★ここはスコープをまたいで呼ばれる。LPのJSは「ピッカー」「カート」「ドロワー」の
       3つの入れ物に分かれていて、yen もそれぞれが別に持っている（2728/3275/3511行）。
       paidyShow と同じ場所＝どこからでも見える位置に置き、整形も自前で持つ。
       ピッカー側に置いて renderType から呼び、ReferenceError で
       色選択後の描画が丸ごと止まった（2026/10/09・docs/pitfalls.md の実例と同じ）。

     出すのは2つがそろったときだけ。
       ・掲出中のカウントダウンバーが画面にある（＝セール期間の中）
       ・その商品に通常価格（compare_at_price）が入っている
     片方だけでは出さない。商品側の通常価格を外し忘れても、バーの終了日時で
     LPの値引き表記は止まる。バーが出ていても値引きの無い商品には出ない。 */
  function saleYen(n){ return '¥'+String(n).replace(/\B(?=(\d{3})+(?!\d))/g,','); }
  /* ★バーは position:fixed なので offsetParent は必ず null になる。
     クーポンの coupon() と同じ書き方にすると常に「出ていない」になる */
  function saleOn(){
    var b=document.querySelector('[data-lp2cd]');
    return !!(b && !b.hidden && (b.offsetWidth||b.offsetHeight||b.getClientRects().length));
  }
  /* 通常価格。セール中でない・入っていない・販売価格以下なら 0（＝出さない） */
  function wasOf(now,was){ return (saleOn() && was>0 && was>now) ? was : 0; }
  function offPct(now,was){ return Math.max(1, Math.round((1-now/was)*100)); }
  /* 「¥45,900 3%OFF」の塊。pct に false を渡すと打ち消しだけ */
  function wasTag(now,was,pct){
    var w=wasOf(now,was); if(!w) return '';
    return '<s class="wasp">'+saleYen(w)+'</s>'+
      (pct===false?'':'<i class="offp">'+offPct(now,w)+'%OFF</i>');
  }
  /* セールの終了日時。カウントダウンバーの data-end-ts（ストアのタイムゾーンで作った秒）。
     表示は見ている端末のタイムゾーンで出る。国内からの閲覧を前提にしている */
  function saleUntil(){
    var b=document.querySelector('[data-lp2cd]'); if(!b) return '';
    var ts=parseInt(b.getAttribute('data-end-ts'),10)||0; if(!ts) return '';
    var d=new Date(ts*1000), W=['日','月','火','水','木','金','土'];
    return (d.getMonth()+1)+'/'+d.getDate()+'（'+W[d.getDay()]+'）'+
      ('0'+d.getHours()).slice(-2)+':'+('0'+d.getMinutes()).slice(-2);
  }
  /* 掲出期間が終わった瞬間に、打ち消しとオフ率を一緒に落とす。
     カウントダウンのJSは終了時にバーを hidden にするので、それを見て body のクラスを外す */
  function syncSale(){ document.body.classList.toggle('lp-sale', saleOn()); }

  /* ── 見た目を組み立てる3つ。原本と特等席LPで同じ表示にするため、ここに集める ──
     ① 追従バー／商品カード … 金額の上の行に 通常価格＋オフ率
     ② セット選択チップ      … 打ち消し＋色付きの販売価格（セールでなければ素の金額）
     ③ カートの合計          … 通常価格・引いた額・販売価格・期限 */
  function saleBarHTML(price,now,was){
    var w=wasTag(now,was);
    return (w?'<span class="wasline">'+w+'</span>':'')+price+'<small>から・税込</small>';
  }
  function salePriceChip(now,was){
    var w=wasTag(now,was,false);
    return w ? (w+'<b class="nowp">'+saleYen(now)+'</b>') : saleYen(now);
  }
  /* tail は「税込・送料無料 ／ 2点」などの <small> ごと受け取る */
  function saleTotalHTML(total,wasTotal,tail){
    var w=wasOf(total,wasTotal), until=w?saleUntil():'';
    return (w?'<span class="wasline"><s class="wasp">'+saleYen(w)+'</s>'+
              '<i class="offamt">−'+saleYen(w-total)+'（'+offPct(total,w)+'%OFF）</i></span>':'')+
      '<span'+(w?' class="nowp"':'')+'>'+saleYen(total)+'</span>'+(tail||'')+
      (until?'<span class="saleuntil saler">この価格は <b>'+until+'</b> まで</span>':'');
  }
  /* 特等席LPからは window 経由で呼ぶ。移植が外れても落ちないよう、呼ぶ側で有無を見る */
  window.__lpSaleOn=saleOn; window.__lpSyncSale=syncSale;
  window.__lpBarHTML=saleBarHTML; window.__lpPriceChip=salePriceChip;
  window.__lpTotalHTML=saleTotalHTML;
  document.addEventListener('DOMContentLoaded',syncSale);
  window.addEventListener('load',syncSale);
  /*SALEJS:END*/
  function paidyShow(id, amount){
    var pm=document.getElementById(id); if(!pm) return;
    if(!amount){ pm.hidden=true; pm.setAttribute('data-amount',''); return; }
    pm.hidden=false;
    if(pm.getAttribute('data-amount')===amount && pm.children.length) return;
    pm.setAttribute('data-amount', amount);
    paidyRefresh();
  }
  function paidyRefresh(){
    clearTimeout(paidyTimer);
    paidyTimer=setTimeout(function(){
      // 読み込み済みなら公式の再描画命令を使う
      if(typeof window._paidy==='function'){
        try{ window._paidy('pm:refresh'); return; }catch(e){}
      }
      // まだ読めていないときだけ1回だけ読む（本番は head で既に読まれている）
      if(!paidyScript){
        paidyScript=document.createElement('script');
        paidyScript.src=PAIDY_SRC;
        document.body.appendChild(paidyScript);
      }
    }, 150);
  }
  
;

  // LEEEP が読めた環境でだけ描画し、静的フォールバックを隠す。
  // 読めない環境（アーティファクトはCSPで外部スクリプトを遮断）では何もせず静的版のまま。
  document.addEventListener('DOMContentLoaded', function(){
    if (typeof LeeepCite === 'undefined') return;
    // LEEEPのタグは商品IDを要求する。本番のLiquidが window.LEEEP_PID に代表商品のIDを入れる
    var lp = window.LEEEP_PID ? { product_id: String(window.LEEEP_PID) } : {};
    LeeepCite.init(Object.assign({ tag_id: '1547876899760422912' }, lp));
    LeeepCite.init(Object.assign({ tag_id: '1477932192326778880' }, lp));   // FVの ★平均と件数（動的）
    // FVの★はLEEEPの数値だけ借りて、表記はこちらで作る。
    // ウィジェットの見た目はレビューセクションと重なるので出さない
    var sc = document.getElementById('leeep-tag-1477932192326778880');
    var scfb = document.getElementById('fvscore-fb');
    var t2 = setInterval(function(){
      if (!sc) { clearInterval(t2); return; }
      var txt = (sc.innerText || '').replace(/\s/g, '');
      var m = txt.match(/([0-9]+(?:\.[0-9]+)?)[^0-9]*?([0-9,]+)件/);
      if (m) {
        if (scfb) scfb.textContent = '★' + m[1] + '（' + m[2] + '件のレビュー）';
        sc.hidden = true;
        clearInterval(t2);
      }
    }, 200);
    setTimeout(function(){ clearInterval(t2); }, 8000);
    var host = document.getElementById('leeep-tag-1547876899760422912');
    var fb = document.getElementById('rv-static');
    // 子要素の有無では判定しない。LEEEPは登録ドメイン以外だと空の器だけ作って中身を返さないため、
    // 実際に高さが出たときだけフォールバックを隠す。
    var t = setInterval(function(){
      if (host && host.getBoundingClientRect().height > 120) {
        if (fb) fb.hidden = true; clearInterval(t);
      }
    }, 200);
    setTimeout(function(){ clearInterval(t); }, 8000);
  });
  
;

var b=document.body,t=document.getElementById('t');
if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches){
  document.querySelectorAll('video').forEach(function(v){v.removeAttribute('autoplay');v.pause();v.setAttribute('controls','controls');});
}
t.addEventListener('click',function(){
  var on=b.classList.toggle('notes');
  t.textContent=on?'注記を隠す':'注記を表示';
  t.setAttribute('aria-pressed',on?'true':'false');
});
// ================= レビュー用のしくみ =================
// 文字の編集 / セクションの並び替え・非表示 / 変更の書き出し
// db が使えれば全員で共有、使えなければこの端末だけに保存
// 編集対象は「列挙」ではなく「除外」で決める。
// テキストを直接持ち、中にブロック要素を含まない要素＝文字の入れ物、とみなす。
var ED_SKIP='.cart,.secmark,.swtool,.chrome,.note,.offnote,.stickybar,.care i';
var ED_BLOCK='div,section,article,ul,ol,dl,table,thead,tbody,tr,figure,details,video,img,'+
  'picture,button,input,textarea,select,header,footer,nav,form,iframe,hr';
var ED_SKIPTAG={SCRIPT:1,STYLE:1,BR:1,IMG:1,VIDEO:1,SOURCE:1,SVG:1,PATH:1,OPTION:1};
var LS='loosy-review-v1';
var DB=null, state={text:{},order:[],hidden:[],img:{}}, applying=false;

function nodes(){
  var stage=document.querySelector('.stage'); if(!stage) return [];
  var out=[];
  Array.prototype.forEach.call(stage.querySelectorAll('*'),function(el){
    if(ED_SKIPTAG[el.tagName]) return;
    if(el.closest(ED_SKIP)) return;
    var has=false, cn=el.childNodes;
    for(var i=0;i<cn.length;i++){ if(cn[i].nodeType===3 && cn[i].textContent.trim()){ has=true; break; } }
    if(!has) return;
    if(el.querySelector(ED_BLOCK)) return;
    out.push(el);
  });
  return out;
}
function hash32(str){var h=5381,i=str.length;while(i)h=(h*33)^str.charCodeAt(--i);return (h>>>0).toString(36);}
var EDN=nodes();
(function(){
  // キーは位置ではなく「どのセクションの、どの原文か」。
  // 私が別のセクションを足しても既存の編集はズレない。
  // 逆にその文の原文を私が書き換えたら、キーが変わり古い編集は自動で外れる。
  // 同じ文言が同じセクションに複数あるときだけ、出現順で区別する（1つ目は従来キーのまま）。
  var seen={};
  EDN.forEach(function(el){
    el.dataset.orig=el.innerHTML;
    var sw=el.closest('.swrap');
    var base=(sw?sw.id:'root')+':'+hash32(el.dataset.orig);
    var n=seen[base]=(seen[base]||0)+1;
    el.dataset.t=(n===1)?base:(base+'#'+n);
  });
})();
var WRAPS=Array.prototype.slice.call(document.querySelectorAll('.swrap'));
var STAGE=WRAPS.length?WRAPS[0].parentNode:null;

// 保存済みの並び順は、セクション構成が変わると使えなくなる。
// （旧リストに無いセクションが先頭に取り残され、全体がバラバラになる）
// 現在のセクションと完全に一致するときだけ採用する。
var IDS=WRAPS.map(function(w){return w.id});
var staleOrder=false;
function orderOK(o){
  if(!o||!o.length) return false;
  if(o.length!==IDS.length) return false;
  for(var i=0;i<o.length;i++){ if(IDS.indexOf(o[i])<0) return false; }
  return true;
}
function readLocal(){ try{return JSON.parse(localStorage.getItem(LS)||'{}')}catch(e){return {}} }
function writeLocal(){ try{localStorage.setItem(LS,JSON.stringify(state))}catch(e){} }
function save(){
  writeLocal();
  if(DB){ DB.doc('review/state').set(state).catch(function(e){
    try{console.warn('save failed',e)}catch(_){} }); }
}
// このブラウザで入れた編集。サーバの内容で上書きされて消えないよう保持する。
var MINE={};
// 画像の差し替えも同じ。state を丸ごと set で書くので、
// 古いスナップショットが来ると自分の差し替え登録が消える（＝差し替えが戻る）。
var MYIMG={};
// localStorage に入りきらなかったときの控え。表示だけはこれで維持する。
var MEMIMG={};
function apply(st,remote){
  applying=true;
  var t=st.text||{};
  if(remote){
    // サーバ優先で他の人の編集を取り込みつつ、自分の編集は必ず残す
    var m={}; for(var k in t) m[k]=t[k];
    for(var k2 in MINE) m[k2]=MINE[k2];
    t=m;
  }else{
    for(var k3 in t) MINE[k3]=t[k3];
  }
  var im=st.img||((state&&state.img)||{});
  if(remote){
    var mi={}; for(var i1 in im) mi[i1]=im[i1];
    for(var i2 in MYIMG) mi[i2]=MYIMG[i2];
    im=mi;
  }else{
    for(var i3 in im) MYIMG[i3]=im[i3];
  }
  var ord=(st.order&&st.order.length)?st.order:((state&&state.order)||[]);
  if(ord.length && !orderOK(ord)){ ord=[]; staleOrder=true; }
  state={text:t, order:ord,
    hidden:(st.hidden&&st.hidden.length)?st.hidden:((state&&state.hidden)||[]),
    img:im};
  if(window.__applyImages) window.__applyImages();
  EDN.forEach(function(el){
    var v=state.text[el.dataset.t];
    if(v!=null && el.innerHTML!==v) el.innerHTML=v;
  });
  if(state.order.length && STAGE){
    state.order.forEach(function(id){
      var el=document.getElementById(id); if(el) STAGE.appendChild(el);
    });
    var fn=document.querySelector('.footnote'); if(fn) STAGE.appendChild(fn);
  }
  WRAPS.forEach(function(w){ w.classList.toggle('off', state.hidden.indexOf(w.id)>=0); });
  applying=false;
}

// --- セクションのツールバー
WRAPS.forEach(function(w){
  var bar=document.createElement('div'); bar.className='swtool';
  var nm=document.createElement('span'); nm.className='nm'; nm.textContent=w.dataset.name||w.id;
  var up=document.createElement('button'); up.type='button'; up.textContent='▲';
  var dn=document.createElement('button'); dn.type='button'; dn.textContent='▼';
  var hd=document.createElement('button'); hd.type='button'; hd.textContent='非表示';
  var note=document.createElement('div'); note.className='offnote';
  note.textContent='（このセクションは非表示）';
  up.onclick=function(){ var pv=w.previousElementSibling;
    if(pv&&pv.classList.contains('swrap')){ STAGE.insertBefore(w,pv); syncOrder(); } };
  dn.onclick=function(){ var nx=w.nextElementSibling;
    if(nx&&nx.classList.contains('swrap')){ STAGE.insertBefore(nx,w); syncOrder(); } };
  hd.onclick=function(){
    var off=w.classList.toggle('off');
    var k=state.hidden.indexOf(w.id);
    if(off && k<0) state.hidden.push(w.id);
    if(!off && k>=0) state.hidden.splice(k,1);
    hd.textContent=off?'表示に戻す':'非表示';
    save();
  };
  bar.appendChild(nm); bar.appendChild(up); bar.appendChild(dn); bar.appendChild(hd);
  w.insertBefore(bar,w.firstChild); w.appendChild(note);
  w._hd=hd;
});
function syncOrder(){
  state.order=Array.prototype.map.call(document.querySelectorAll('.swrap'),function(x){return x.id});
  save();
}

// --- 起動時：保存済みを反映（db が来ても自分の編集は消さない）
apply(readLocal());
if(window.__applyImages) window.__applyImages();
// 構成が変わって使えなくなった並び順は、保存先からも消しておく
if(staleOrder){ staleOrder=false; writeLocal(); }
WRAPS.forEach(function(w){ if(w._hd) w._hd.textContent=w.classList.contains('off')?'表示に戻す':'非表示'; });

var pushed=false;
if(window.claude && claude.use){
  claude.use('db').then(function(db){
    if(!db) return;
    DB=db;
    db.doc('review/state').onSnapshot(function(snap){
      if(!snap.exists) return;
      var d=snap.data()||{};
      var lost=false, rt=d.text||{};
      for(var k in MINE){ if(rt[k]!==MINE[k]) lost=true; }
      var ri=d.img||{};
      for(var ki in MYIMG){ if(!ri[ki]) lost=true; }
      apply(d,true);
      if(staleOrder){ staleOrder=false; save(); }
      // サーバに無い自分の編集があれば書き戻して揃える
      if(lost && !pushed){ pushed=true; setTimeout(function(){ pushed=false; save(); },300); }
      // 他の人がアップロードした画像を取りに行く（本体とは別ドキュメント）
      Object.keys(state.img||{}).forEach(function(k){
        if(state.img[k].t!=='up') return;
        var has=null; try{ has=localStorage.getItem(imgLS(k)); }catch(e){}
        if(has) return;
        db.doc('imgs/'+k).get().then(function(sn){
          if(!sn||!sn.exists) return;
          var d=(sn.data()||{}).d; if(!d) return;
          try{ localStorage.setItem(imgLS(k),d); }catch(e){}
          window.__applyImages();
        }).catch(function(){});
      });
      WRAPS.forEach(function(w){ if(w._hd) w._hd.textContent=w.classList.contains('off')?'表示に戻す':'非表示'; });
      var s1=document.getElementById('syncnote'); if(s1) s1.hidden=false;
    },function(){});
  }).catch(function(){});
}

// --- 文字編集
var ed=document.getElementById('ed'), edrst=document.getElementById('edrst');
ed.addEventListener('click',function(){
  var on=b.classList.toggle('editing');
  ed.textContent=on?'編集を終える':'文字を編集';
  ed.setAttribute('aria-pressed',on?'true':'false');
  edrst.hidden=!on;
  EDN.forEach(function(el){
    el.contentEditable=on?'true':'false';
    if(on&&!el.dataset.edb){ el.dataset.edb='1';
      el.addEventListener('input',function(){
        if(applying)return;
        state.text[el.dataset.t]=el.innerHTML;
        MINE[el.dataset.t]=el.innerHTML;
        save(); }); }
  });
});
edrst.addEventListener('click',function(){
  if(edrst.dataset.armed!=='1'){ edrst.dataset.armed='1';
    edrst.textContent='本当にリセット（コメントは残ります）';
    setTimeout(function(){ if(edrst.dataset.armed==='1'){ edrst.dataset.armed='';
      edrst.textContent='編集をリセット'; } },5000);
    return; }
  state={text:{},order:[],hidden:[],img:{}}; MINE={};
  try{Object.keys(localStorage).forEach(function(k){ if(k.indexOf(LS+':img:')===0) localStorage.removeItem(k); });}catch(e){}
  EDN.forEach(function(el){ el.innerHTML=el.dataset.orig; });
  writeLocal();
  if(DB){ DB.doc('review/state').set(state).finally(function(){location.reload()}); }
  else location.reload();
});

// --- 画像の差し替え
// キーは build.py が埋めた data-k（＝素材トークン名）。位置ではなく素材で持つので、
// セクションを並べ替えても差し替えは追従し、書き出した結果をそのまま build.py に反映できる。
// アップロードした画像は本体stateに入れず imgs/<トークン> に分けて持つ（1ドキュメントの上限対策）。
var IMGCAP=1000, IMGQ=0.82, IMGMAX=620000;
function imgLS(k){ return LS+':img:'+k; }
function imgData(k){
  var v=state.img&&state.img[k]; if(!v) return null;
  if(v.t==='url') return v.v;
  if(MEMIMG[k]) return MEMIMG[k];
  try{ return localStorage.getItem(imgLS(k)); }catch(e){ return null; }
}
// 差し替えた画像は「元のデザインが持っていた枠」に切り抜いて収める。
// そうしないと素の写真の縦横比がそのまま出て、前後のレイアウトが動く。
// 枠の決め方は2通り。CSS が縦横比を決めているならそれが枠（cover に任せるだけでよい）。
// 決めていない要素（.shot の width:100%/height:auto など）は、元画像の縦横比が枠。
// build.py が素材を枠どおりに焼いているので、元画像の比率＝デザインの枠になる。
function measureFrames(){
  var els=Array.prototype.slice.call(document.querySelectorAll('[data-k]'));
  var left=els.length; if(!left) return;
  var done=function(){ if(--left===0) window.__applyImages(); };
  els.forEach(function(el){
    if(el.dataset.frame){ done(); return; }
    if(el.tagName!=='IMG'){ el.dataset.frame='css'; done(); return; }
    // 自分が後から入れたインライン値を外して、CSS が決めている比率だけを読む
    var keep=el.style.aspectRatio; el.style.aspectRatio='';
    var car=((window.getComputedStyle(el).aspectRatio)||'auto').trim();
    el.style.aspectRatio=keep;
    if(car&&car!=='auto'){ el.dataset.frame='css'; done(); return; }
    var src=el.dataset.origsrc||el.getAttribute('src')||'';
    if(!src){ el.dataset.frame='css'; done(); return; }
    var t=new Image();
    t.onload=function(){
      el.dataset.frame=(t.naturalWidth&&t.naturalHeight)?(t.naturalWidth+'/'+t.naturalHeight):'css';
      done(); };
    t.onerror=function(){ el.dataset.frame='css'; done(); };
    t.src=src;
  });
}
// 枠の縦横比。CSS が枠を決めている要素は、実際に描かれている箱をそのまま使う
function frameAR(k){
  var el=document.querySelector('[data-k="'+k+'"]'); if(!el) return 1;
  var fr=el.dataset.frame;
  if(fr&&fr!=='css'){ var q=fr.split('/'); return (+q[0]/+q[1])||1; }
  return (el.offsetWidth&&el.offsetHeight)?(el.offsetWidth/el.offsetHeight):1;
}
window.__applyImages=function(){
  var m=state.img||{};
  Array.prototype.forEach.call(document.querySelectorAll('[data-k]'),function(el){
    var k=el.dataset.k;
    if(!el.dataset.origsrc) el.dataset.origsrc=el.getAttribute('src')||'';
    var d=m[k]?imgData(k):null;
    var want=d||el.dataset.origsrc;
    if(el.getAttribute('src')!==want) el.setAttribute('src',want);
    if(d){
      var fr=el.dataset.frame;
      if(fr&&fr!=='css') el.style.aspectRatio=fr.split('/').join(' / ');
      el.style.objectFit='cover';
      el.style.objectPosition=(m[k]&&m[k].pos)||'50% 50%';
    }else if(el.style.objectFit==='cover'){
      // 元に戻したときは、こちらで足した指定だけを外す（CSS の cover には触らない）
      el.style.aspectRatio=''; el.style.objectFit=''; el.style.objectPosition='';
    }
  });
  if(window.__rerenderPicker) window.__rerenderPicker();
};
// 大きすぎる画像はここで縮める。上限に収まるまで品質→サイズの順に落とす。
function shrink(file,cb){
  var fr=new FileReader();
  fr.onload=function(){
    var im=new Image();
    im.onload=function(){
      var w=im.width,h=im.height,sc=Math.min(1,IMGCAP/Math.max(w,h));
      function enc(scale,q){
        var c=document.createElement('canvas');
        c.width=Math.max(1,Math.round(w*scale)); c.height=Math.max(1,Math.round(h*scale));
        c.getContext('2d').drawImage(im,0,0,c.width,c.height);
        return c.toDataURL('image/jpeg',q);
      }
      var q=IMGQ, scale=sc, out=enc(scale,q), guard=0;
      while(out.length>IMGMAX && guard++<6){
        if(q>0.55) q-=0.1; else scale*=0.8;
        out=enc(scale,q);
      }
      cb(out,out.length>IMGMAX);
    };
    im.onerror=function(){ cb(null,false); };
    im.src=fr.result;
  };
  fr.onerror=function(){ cb(null,false); };
  fr.readAsDataURL(file);
}
(function(){
  var wrap=document.getElementById('imgwrap'), btn=document.getElementById('imgbtn'),
      kEl=document.getElementById('imgk'), pv=document.getElementById('imgprev'),
      fin=document.getElementById('imgfin'), msg=document.getElementById('imgmsg'),
      urlIn=document.getElementById('imgurl');
  var fbox=document.getElementById('imgframe'),
      cx=document.getElementById('imgcx'), cy=document.getElementById('imgcy'),
      cxv=document.getElementById('imgcxv'), cyv=document.getElementById('imgcyv');
  var cur=null, cropT=null;
  var MSG0=msg.innerHTML;
  // プレビューの箱を、その枠と同じ形にする（ダイアログに収まる範囲で最大）
  function fitFrame(k){
    var ar=frameAR(k), W=388, H=260, w=W, h=W/ar;
    if(h>H){ h=H; w=H*ar; }
    if(w>W){ w=W; h=W/ar; }
    fbox.style.width=Math.round(w)+'px'; fbox.style.height=Math.round(h)+'px';
  }
  function showPos(){
    var p=cx.value+'% '+cy.value+'%';
    pv.style.objectPosition=p;
    cxv.textContent=cx.value+'%'; cyv.textContent=cy.value+'%';
    return p;
  }
  function cropUI(k){
    var rec=(state.img||{})[k];
    b.classList.toggle('imgdlg-crop',!!rec);
    var xy=((rec&&rec.pos)||'50% 50%').split(/\s+/);
    cx.value=parseInt(xy[0],10); cy.value=parseInt(xy[1],10);
    if(isNaN(+cx.value)) cx.value=50;
    if(isNaN(+cy.value)) cy.value=50;
    showPos();
  }
  function onCrop(){
    var p=showPos(); if(!cur) return;
    var rec=(state.img||{})[cur]; if(!rec) return;
    rec.pos=p; MYIMG[cur]=rec;
    window.__applyImages();
    clearTimeout(cropT); cropT=setTimeout(save,300);
  }
  cx.addEventListener('input',onCrop); cy.addEventListener('input',onCrop);
  document.getElementById('imgcrst').addEventListener('click',function(){
    cx.value=50; cy.value=50; onCrop(); });
  function keyOf(el){
    if(el.id==='pv-img'){
      var now=el.getAttribute('src'), bank=document.querySelectorAll('.swbank [data-k]');
      for(var i=0;i<bank.length;i++){ if(bank[i].getAttribute('src')===now) return bank[i].dataset.k; }
    }
    if(el.dataset&&el.dataset.k) return el.dataset.k;
    var b=el.closest?el.closest('button'):null;
    if(b&&b.dataset.c){
      var sw=document.getElementById('sw-'+b.dataset.c.toLowerCase().replace(/\s+/g,'-'));
      if(sw&&sw.dataset.k) return sw.dataset.k;
    }
    return null;
  }
  function open(k){
    cur=k; kEl.textContent=k;
    var el=document.querySelector('[data-k="'+k+'"]');
    pv.src=(el&&el.getAttribute('src'))||'';
    fitFrame(k); cropUI(k);
    urlIn.value=(state.img&&state.img[k]&&state.img[k].t==='url')?state.img[k].v:'';
    msg.innerHTML=MSG0;
    b.classList.add('imgdlg-on');
  }
  function close(){ b.classList.remove('imgdlg-on'); cur=null; }
  function setImg(k,rec,data){
    state.img=state.img||{};
    // 同じ枠に別の写真を入れ直したときは、選んでいた切り抜き位置を引き継ぐ
    var prev=state.img[k];
    if(prev&&prev.pos&&!rec.pos) rec.pos=prev.pos;
    state.img[k]=rec;
    MYIMG[k]=rec;
    if(data){ MEMIMG[k]=data;
      try{ localStorage.setItem(imgLS(k),data); }catch(e){
      msg.innerHTML='この端末には保存しきれませんでした（容量）。表示は差し替わっていますが、再読み込みで戻ります。'; } }
    window.__applyImages();
    var el=document.querySelector('[data-k="'+k+'"]'); if(el) pv.src=el.getAttribute('src');
    if(cur===k){ fitFrame(k); cropUI(k); }
    save();
    if(DB&&data){ DB.doc('imgs/'+k).set({d:data}).catch(function(){
      msg.innerHTML='共有用の保存に失敗しました。この端末では差し替わっています。'; }); }
  }
  btn.addEventListener('click',function(){
    var on=b.classList.toggle('imging');
    btn.textContent=on?'差し替えを終える':'画像を差し替え';
    btn.setAttribute('aria-pressed',on?'true':'false');
    if(!on) close();
  });
  document.addEventListener('click',function(e){
    if(!b.classList.contains('imging')) return;
    var el=e.target;
    if(el.closest('.imgdlg')||el.closest('.tbar')) return;
    if(el.tagName!=='IMG'&&el.tagName!=='VIDEO') return;
    var k=keyOf(el); if(!k) return;
    e.preventDefault(); e.stopPropagation();
    open(k);
  },true);
  document.getElementById('imgclose').addEventListener('click',close);
  wrap.addEventListener('click',function(e){ if(e.target===wrap) close(); });
  document.getElementById('imgfile').addEventListener('click',function(){ fin.click(); });
  fin.addEventListener('change',function(){
    var f=fin.files&&fin.files[0]; if(!f||!cur) return;
    var k=cur;
    msg.textContent='読み込み中…';
    shrink(f,function(d,over){
      fin.value='';
      if(!d){ msg.textContent='この画像は読み込めませんでした。'; return; }
      setImg(k,{t:'up',n:f.name},d);
      msg.innerHTML='差し替えました（'+Math.round(d.length/1024)+'KB）。'+(over?'<b>まだ大きいので共有保存に失敗する場合があります。</b>':'');
    });
  });
  document.getElementById('imgurlgo').addEventListener('click',function(){
    var u=urlIn.value.trim(); if(!u||!cur) return;
    var k=cur;
    var test=new Image();
    test.onload=function(){ setImg(k,{t:'url',v:u},null); msg.textContent='差し替えました。'; };
    test.onerror=function(){
      msg.innerHTML='<b>このURLは読み込めませんでした。</b>アーティファクト上では外部の画像が読み込めません（ブラウザ側でブロックされます）。ファイルを選ぶをお使いください。';
    };
    test.src=u;
  });
  document.getElementById('imgrevert').addEventListener('click',function(){
    if(!cur) return; var k=cur;
    if(state.img) delete state.img[k];
    delete MYIMG[k]; delete MEMIMG[k];
    try{ localStorage.removeItem(imgLS(k)); }catch(e){}
    window.__applyImages(); save();
    if(DB) DB.doc('imgs/'+k).delete().catch(function(){});
    var el=document.querySelector('[data-k="'+k+'"]'); if(el) pv.src=el.getAttribute('src');
    b.classList.remove('imgdlg-crop'); pv.style.objectPosition='50% 50%';
    msg.textContent='元に戻しました。';
  });
})();
// 起動時の apply() はこの定義より前に走るので、ここで一度あてる
window.__applyImages();
measureFrames();

// --- 構成モード
var lay=document.getElementById('lay');
lay.addEventListener('click',function(){
  var on=b.classList.toggle('laying');
  lay.textContent=on?'構成の編集を終える':'構成を編集';
  lay.setAttribute('aria-pressed',on?'true':'false');
});

/* ★文言の中の {色数} {素材数} を、いま出ている商品の実数に差し替える（2026/10/06）。
   「全26色」「3素材」のような数字がテンプレートの設定に5箇所べた書きされていて、
   色を1つ足すだけで全部が嘘になる。設定には数字ではなく記号を書いてもらい、
   ここで実数に置き換える。記号が無ければ何も起きないので、既存の文言はそのままでいい。
   数えるのは「いまLPに出ている」商品だけ。発売前のものは CART に入っていないので
   発売日の前に数字が増えることはない */
window.addEventListener('load',function(){
  if(typeof CART==='undefined'||!CART.p) return;
  var cols={}, mats={};
  CART.p.forEach(function(p){ if(p.c) cols[p.c]=1; if(p.f) mats[p.f]=1; });
  var num={'{色数}':String(Object.keys(cols).length),
           '{素材数}':String(Object.keys(mats).length)};
  var re=/\{(色数|素材数)\}/;
  var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null), n, hit=[];
  while((n=w.nextNode())){ if(re.test(n.nodeValue)) hit.push(n); }
  hit.forEach(function(t){
    t.nodeValue=t.nodeValue.replace(/\{(色数|素材数)\}/g,function(m){ return num[m]||m });
  });
  window.LPNUM=num;   /* 確認用。いくつに置き換えたかが見える */
});

// --- S8 サイズタブ（CARTの実データで切り替え）
// CART は後続の <script> で定義されるため load 後に実行する
window.addEventListener('load',function(){
  var tabs=Array.prototype.slice.call(document.querySelectorAll('#s8 .tabs span'));
  var chips=document.getElementById('chips');
  if(!tabs.length||!chips||typeof CART==='undefined') return;
  // 素材の並びは S10 の FULL PALETTE と同じ（機能 → 素材 → 色）
  // v33 の3段構造（機能 → 素材 → 色）。機能を見出しに戻し、素材行には短い特徴だけ置く
  var FN=[
    ['🌀','WASHABLE','自宅で洗える',[
      ['Medium Corduroy','洗える','ふわふわな手触りの10mmピッチコーデュロイ',
        ['Ivory','Beige','Green','Navy','Charcoal','Black','Gray','Brown','Olive','Mustard','Mint','Blood Orange','Coral Pink']],
      ['Slim Corduroy','洗える','さらりとオールシーズン快適な5mmピッチコーデュロイ',
        ['Powder Blue','Soft Yellow','Dark Blue','Dark Brown','Dark Green']],
      ['Canvas','洗える','さらりとオールシーズン快適なキャンバス生地',
        ['GT Check','Brown Check','Charcoal Check']]
    ]],
    ['💧','WATER PROOF','水・汚れをはじく',[
      ['Vegan Leather','水・汚れをはじく','ややつやと光沢感のあるタイプと、しっとりマットな質感のタイプ',
        ['Glossy Pink','GT Beige','Matte Black','Matte Brown','Matte Khaki']]
    ]],
    /* ★数量限定の括り（2026/10/06）。スウォッチの末尾に出す。
       色のリストを手で書かず '@<生地名>' と書くと、その生地の色を商品データから集める。
       新色が増えても、生地のメタフィールドさえ入っていればここを触らなくていい */
    ['✨','LIMITED EDITION','数量限定',[
      ['Chenille','数量限定','秋冬にぴったりの数量限定シェニール生地','@Chenille']
    ]]
  ];
  /* 色のリストの代わりに '@<生地名>' と書けるようにする。
     商品データ（CART）の f（custom.loosy_fabric_material）で拾う */
  function listOf(g){
    if(Object.prototype.toString.call(g[3])!=='[object String]') return g[3];
    var want=g[3].slice(1), out=[];
    (CART.p||[]).forEach(function(p){
      if(p && p.f===want && p.c && out.indexOf(p.c)<0) out.push(p.c);
    });
    return out;
  }
  var matOf={};
  FN.forEach(function(f){ f[3].forEach(function(g){ listOf(g).forEach(function(c){ matOf[c]=g[0]; }); }); });
  /* 確認用。どの括りに何色入ったかが見える。
     「新色が出ない」ときに、生地のメタフィールドが入っているかをここで切り分ける */
  try{
    window.LPGROUPS=[];
    FN.forEach(function(f){ f[3].forEach(function(g){
      window.LPGROUPS.push({群:f[1], 素材:g[0], 色:listOf(g)});
    }); });
  }catch(e){}
  var pv=document.getElementById('pv-img');
  function yen(n){ return '¥'+String(n).replace(/\B(?=(\d{3})+(?!\d))/g,','); }
  function roomId(c){ return 'c-'+c.toLowerCase().replace(/\s+/g,'-'); }
  function swId(c){ return 'sw-'+c.toLowerCase().replace(/\s+/g,'-'); }
  function basePrice(p){ var m=null; p.v.forEach(function(v){ if(v[3]!==0 && (m===null||v[2]<m)) m=v[2]; }); return m; }
  /* basePrice と同じ1件（＝その色で一番安い在庫ありの構成）の通常価格。
     最安の構成と通常価格を別々に取ると「¥44,707 ← ¥58,000」のような嘘になるので、
     必ず同じバリアントから両方を取る */
  function baseWas(p){ var m=null,w=0; p.v.forEach(function(v){ if(v[3]!==0 && (m===null||v[2]<m)){ m=v[2]; w=v[5]||0; } }); return w; }
  // 色を選ぶ前は、そのサイズを部屋に置いたコーディネート写真を出す
  var CO={'1人掛け':'co-1p','2人掛け':'co-2p','ミニ':'co-mini'};
  var SZ={'1人掛け':'sz-1p','2人掛け':'sz-2p','ミニ':'sz-mini'};
  var BX={'1人掛け':'bx-1p','2人掛け':'bx-2p','ミニ':'bx-mini'};
  // 箱サイズ（W×D×H・cm）。FAQと同じ数値
  var BOX={'1人掛け':'74 × 60 × 92','2人掛け':'115 × 80 × 64','ミニ':'72 × 45 × 66'};
  var car=document.getElementById('pv-car'), dots=document.getElementById('pv-dots'),
      pvwrap=car?car.parentNode:null, szImg=document.getElementById('sz-img'),
      bxDim=document.getElementById('bx-dim'), bxImg=document.getElementById('bx-img'),
      cblock=document.getElementById('cartblock');
  // 写真＝横スワイプ。サイズ・箱はタブを押したときだけ差し替えで出す
  var panes=document.getElementById('pv-panes'),
      pvsize=document.getElementById('pv-size'), pvbox=document.getElementById('pv-box'),
      swipeHint=null, pvidx=null;   // 横スワイプの案内は撤去した
  function carMode(){ if(car) car.scrollLeft=0; setTab(0); }
  function setTab(i){
    if(dots) Array.prototype.forEach.call(dots.children,function(b,n){ b.classList.toggle('on',n===i); });
    if(!car||!panes) return;
    car.hidden = (i!==0);
    panes.hidden = (i===0);
    if(pvsize) pvsize.hidden = (i!==1);
    if(pvbox)  pvbox.hidden  = (i!==2);
    if(swipeHint) swipeHint.hidden = (i!==0) || car.children.length<2;
    if(pvidx) pvidx.hidden = (i!==0) || car.children.length<2;
  }
  if(dots) dots.addEventListener('click',function(e){
    var b=e.target.closest('button'); if(!b) return;
    setTab(+b.dataset.i);
    if(+b.dataset.i===0 && car) car.scrollLeft=0;
  });
  // 選んだ色の商品写真を並べる。本番は Liquid が p.im に画像URLを入れる
  function setPhotos(list, alt){
    if(!car) return;
    // 2枚目以降の写真だけを外す。children を後ろから消すと、
    // 同じ器に置いてある注釈（.pvset）まで一緒に消えてしまう
    Array.prototype.slice.call(car.querySelectorAll('img')).slice(1)
      .forEach(function(x){ if(x.parentNode===car) car.removeChild(x); });
    pv.src=list[0]; pv.alt=alt;
    list.slice(1).forEach(function(u,n){
      var im=document.createElement('img');
      im.className='shot pvimg'; im.src=u; im.loading='lazy';
      im.alt=alt+'（'+(n+2)+'枚目）';
      car.appendChild(im);
    });
    if(!pvidx){ pvidx=document.createElement('div'); pvidx.className='pvidx';
      car.parentNode.insertBefore(pvidx, dots); }
    pvidx.innerHTML='';
    if(list.length>1) list.forEach(function(_,n){
      var d=document.createElement('i'); if(!n) d.className='on'; pvidx.appendChild(d); });
    car.scrollLeft=0; setTab(0);
  }
  if(car) car.addEventListener('scroll',function(){
    if(!pvidx||!car.clientWidth) return;
    var i=Math.round(car.scrollLeft/car.clientWidth);
    Array.prototype.forEach.call(pvidx.children,function(d,n){ d.classList.toggle('on',n===i); });
  },{passive:true});
  var pbImg=document.getElementById('pb-img'), pbName=document.getElementById('pb-name'),
      pbSub=document.getElementById('pb-sub'), pbPrice=document.getElementById('pb-price');
  /* 「選び直す」の行き先。#s8（セクションの先頭）へ飛ばすと、画面に入るのは
     写真とサイズタブだけで、肝心の色のスウォッチは約700px下＝画面外に残る
     （812pxの画面で実測 chipsTop=707）。押しても色を選べないので、
     スウォッチそのものまで運ぶ。貼りつくバーの高さ分だけ手前で止める。
     カートの上のバー（#c-repick）からも同じ場所へ行く */
  window.__toChips=function(){
    var c=document.getElementById('chips'); if(!c) return;
    /* 色の選択をいったん解除して、そのサイズの「¥◯◯から」の状態に戻す。
       前に選んだ色が残ったままスウォッチへ運んでも、何を選び直しているのか分からない。
       __rerenderPicker は「いま選ばれているサイズタブで描き直す」ので、
       これを呼ぶと showRoom() を通って 色=未選択・カート非表示・最安からの表示 に戻る */
    if(typeof window.__rerenderPicker==='function') window.__rerenderPicker();
    /* 高さは戻したあとに測る。選択中と未選択でバーの高さが変わる */
    var bar=document.getElementById('pv-bar');
    var off=(bar?bar.getBoundingClientRect().height:0)+10;
    window.scrollTo({top:c.getBoundingClientRect().top+window.pageYOffset-off,
      behavior:document.hidden?'auto':'smooth'});
  };
  var pbre=document.getElementById('pb-re');
  if(pbre) pbre.addEventListener('click',function(e){ e.preventDefault(); window.__toChips(); });
  /* #c-pick は render のたびに作り直されるので、委譲で拾う。
     __toChips が無い版（C案）では href="#chips" がそのまま効く */
  document.addEventListener('click',function(e){
    var a=(e.target&&e.target.closest)?e.target.closest('#c-repick'):null;
    if(!a||typeof window.__toChips!=='function') return;
    e.preventDefault(); window.__toChips();
  });
  var pbgo=document.getElementById('pb-go');
  // カート本体が見えているあいだは、バーの「構成を選ぶ」を出さない（同じものが2つに見える）
  var cartSeen=false;
  function syncGo(){
    var t=document.getElementById('cartblock');
    var bar=document.getElementById('pv-bar');
    // 「構成を選ぶ」の出し分けは、カートのブロックが見えているかで決める
    var cr = t && !t.hidden ? t.getBoundingClientRect() : null;
    cartSeen = !!(cr && cr.top < window.innerHeight && cr.bottom > 0);
    if(pbgo) pbgo.hidden = cartSeen || !bar || !bar.classList.contains('picked');
    // バーを引っ込めるのは「セットを選んでいる画面」のときだけ。
    // カートはチップの20px下から始まって431pxあるので、"画面に入ったら消す" だと
    // スウォッチを見ているあいだも消えてしまう。画面の上半分に入ったかで判定する。
    // .away は transform と opacity だけなので、消しても下の内容は動かない
    var cartNear = !!(cr && cr.top < window.innerHeight * 0.45 && cr.bottom > 0);
    /* カート欄を通り過ぎたら上のバーは出さない。ここから下は下の購入バーが
       同じ内容（サイズ・カラー・金額）を持つので、上下で二段になるだけになる */
    var cartPassed = !!(cr && cr.bottom <= 0);
    if(bar) bar.classList.toggle('away', cartNear || cartPassed);
    // 上端に貼りついている瞬間だけ影を出す
    if(bar) bar.classList.toggle('stuck', bar.getBoundingClientRect().top <= 0.5);
    syncSale();
  }
  window.addEventListener('scroll',syncGo,{passive:true});
  // スウォッチを見ているあいだだけ写真を貼りつける。
  // 貼りついた要素は自分の位置で判定できないので、その手前にあるサイズタブを目印にする。
  // タブが画面から上に外れた＝スウォッチの領域に入った、上に戻った＝写真の位置に戻った
  // picking（写真を縮めて貼りつける）は撤去した。
  // いまは色を選んだ時点で .pvbar が貼りつき、その中の120pxの写真で色を確認できる。
  window.addEventListener('resize',syncGo);
  if(pbgo) pbgo.addEventListener('click',function(e){
    e.preventDefault();
    var t=document.getElementById('cartblock'); if(!t||t.hidden) return;
    var y=t.getBoundingClientRect().top+window.pageYOffset-90;
    window.scrollTo({top:y,behavior:document.hidden?'auto':'smooth'});
  });
  (function(){
    var z=document.getElementById('zoom-dlg');
    document.addEventListener('click',function(e){
      if(e.target.closest('#pb-zoom')){
        var im=document.getElementById('pv-img'), zi=document.getElementById('zoom-img');
        zi.src=im.getAttribute('src'); zi.alt=im.alt;
        document.getElementById('zoom-cap').innerHTML=
          document.getElementById('pb-name').textContent+
          '<span>'+document.getElementById('pb-sub').textContent+'</span>';
        document.body.classList.add('zoom-on');
      } else if(e.target.closest('#zoom-close')||e.target===z){ document.body.classList.remove('zoom-on'); }
    });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') document.body.classList.remove('zoom-on'); });
  })();
  (function(){
    var b=document.getElementById('wp-dlg');
    document.addEventListener('click',function(e){
      if(e.target.closest('#wp-open')){ document.body.classList.add('wp-on'); }
      else if(e.target.closest('#wp-close')||e.target===b){ document.body.classList.remove('wp-on'); }
    });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') document.body.classList.remove('wp-on'); });
  })();
  var pbar=document.getElementById('pv-bar');
  function setBar(src,name,sub,price,from,nowN,wasN){
    if(!pbImg) return;
    if(pbar) pbar.classList.toggle('picked',!from);
    var go=document.getElementById('pb-go'); if(go) go.hidden=!!from;
    var re=document.getElementById('pb-re'); if(re) re.hidden=!!from;
    syncGo();
    pbImg.src=src; pbImg.alt=name;
    pbName.textContent=name; pbSub.textContent=sub;
    /* 金額は常に出す。サイズだけのときはそのサイズの最安、色まで選んだあとは
       そのサイズ×カラーの最安を「¥◯◯から」で見せる。構成を選ぶまで金額が
       出ないと、いくらから買えるのかが画面から消えてしまう */
    /* セール中は、金額の上の行に 通常価格（打ち消し）＋オフ率 を出す。
       バーは色を選ぶ前も出ているので、ここの通常価格も「そのサイズ・色の最安」に揃える */
    pbPrice.innerHTML = price ? saleBarHTML(price,nowN,wasN) : '';
    if(typeof paidyShow==='function') paidyShow('paidy-pv', price||null);
  }
  window.__barPrice=function(){};
  if(car){
    car.addEventListener('scroll',function(){
      setTab(Math.round(car.scrollLeft/Math.max(1,car.clientWidth)));
    },{passive:true});
  }
  function showRoom(size,items){
    var setn0=document.getElementById('pv-set'); if(setn0) setn0.hidden=true;
    var el=document.getElementById(CO[size]);
    if(el) setPhotos([el.src], size+'のLOOSYを置いたお部屋');
    var sz=document.getElementById(SZ[size]);
    if(sz&&szImg){ szImg.src=sz.src; szImg.alt=size+'の寸法図'; }
    if(bxDim) bxDim.textContent=BOX[size]||'';
    var bx=document.getElementById(BX[size]);
    if(bx&&bxImg){ bxImg.src=bx.src; bxImg.alt=size+'の梱包箱'; bxImg.dataset.k=bx.dataset.k||''; }
    carMode();
    var pg0=document.getElementById('pickguide'); if(pg0) pg0.hidden=false;
    if(cblock) cblock.hidden=true;
    var min=null,minWas=0;
    items.forEach(function(p){ var b=basePrice(p); if(b!==null&&(min===null||b<min)){ min=b; minWas=baseWas(p); } });
    setBar((el?el.src:''),size,'全'+items.length+'色',(min===null?'':yen(min)),true,min,minWas);
    Array.prototype.forEach.call(chips.querySelectorAll('button'),function(b){
      b.setAttribute('aria-pressed','false');
    });
    if(window.__cartSync) window.__cartSync(size,null);
    setCtas(null);
    // 固定バーの中身は関数にして持っておく。安心の帯をはさんだあと購入の帯に戻るとき、
    // ここを呼び直すだけで「いま選んでいる状態」に復帰できる
    window.sbarFill=function(){
      var th=document.getElementById('sbar-th'); if(th) th.hidden=true;
      if(sbarT) sbarT.innerHTML='<b>'+size+'</b>'+(min===null?'':yen(min)+'から ／ ')+'送料無料';
      if(sbarA){ sbarA.textContent=sbarA0; sbarA.setAttribute('href',sbarH0); sbarA.onclick=null; }
    };
    if(window.__sbarApply) window.__sbarApply();
  }
  var sbarT=document.querySelector('#sbar .t'), sbarA=document.querySelector('#sbar a');
  // ページ下部のCTAも選択状態を引き継ぐ。カートを2つ持たず、選んだ色のまま戻す
  var ctas=Array.prototype.slice.call(document.querySelectorAll('a[data-cta="pick"]'));
  /* ページ内のボタンは「サイズとカラーを選択する」で固定する。
     選択中に「1人掛け Matte Brown でカートに進む」へ変わると、
     色名で長くなって何のボタンなのか読み取りにくかった。
     選んだあと買いに進む導線は、下の追従バーが持っている */
  function setCtas(p){
    ctas.forEach(function(a){
      a.textContent='サイズとカラーを選択する　→';
      a.setAttribute('href','#s8');
      a.onclick=null;
    });
  }
  var sbarA0=sbarA?sbarA.textContent:'', sbarH0=sbarA?sbarA.getAttribute('href'):'#s8';
  function select(p){
    var room=document.getElementById(roomId(p.c));
    var alt='LOOSY '+p.s+'ビーズソファ '+p.c;
    // 色を選んだことを計測に渡す。Shopifyのピクセルは商品ページでしか
    // ViewContent を出さないので、このLPでは自分で出す必要がある。
    // 26色を続けて押すと26件になるため、色ごとに1回だけ・600msまとめて送る
    if(p.v && p.v.length){
      var vid=p.v[0][0], vpr=p.v[0][2];
      if(!window.__vcSent) window.__vcSent={};
      if(!window.__vcSent[vid]){
        clearTimeout(window.__vcT);
        window.__vcT=setTimeout(function(){
          window.__vcSent[vid]=1;
          try{ if(typeof fbq==='function') fbq('track','ViewContent',
            {content_type:'product',content_ids:[String(vid)],value:vpr,currency:'JPY'}); }catch(e){}
          try{ (window.dataLayer=window.dataLayer||[]).push({event:'view_item',
            ecommerce:{currency:'JPY',value:vpr,items:[{item_id:String(vid),item_name:'LOOSY '+p.s+' '+p.c,price:vpr,quantity:1}]}}); }catch(e){}
        },600);
      }
    }
    // 写真は一番高いセットのもの。何が写っているかを右下に出す。
    // セット名は p.set（本番のLiquidが入れる）が無ければ、その色のバリアントの
    // 最高額のものから組み立てる。モックには p.set が無いので後者を通る
    var setn=document.getElementById('pv-set');
    if(setn){
      var nm=p.set;
      if(!nm){ var mx=-1; (p.v||[]).forEach(function(v){ if(v[2]>mx){ mx=v[2]; nm=v[1]; } }); }
      var add=(nm||'').replace(/^ソファ\s*\+?\s*/,'').trim();
      setn.hidden=!add; setn.textContent=add?('※画像は'+add+'付き'):'';
    }
    // 写真は1枚だけ。横スワイプはやめた（サイズ・箱はタブで出す）。
    // 本番はメタフィールドのCDN画像を使う。モックに埋めている素材は400pxしかなく、
    // 表示サイズ408px（Retinaなら816px以上必要）に足りないため
    var src = p.room || (room ? room.src : '');
    var list = src ? [src] : [];
    if(list.length) setPhotos(list, alt); else carMode();
    var pg1=document.getElementById('pickguide'); if(pg1) pg1.hidden=true;
    /* 写真はサイズ別のものを使う。roomId() は色ごとの1枚しか持っておらず、
       どのサイズでも1人掛けの写真になっていた。p.room は本番のLiquidが入れる
       「その商品の一番高いセットのバリアント画像」でサイズが正しい */
    setBar((p.room||(room?room.src:'')),p.s+' '+p.c,(matOf[p.c]||''),yen(basePrice(p)),false,basePrice(p),baseWas(p));
    if(cblock) cblock.hidden=false;
    Array.prototype.forEach.call(chips.querySelectorAll('button'),function(b){
      b.setAttribute('aria-pressed', b.dataset.c===p.c ? 'true':'false');
    });
    if(window.__cartSync) window.__cartSync(p.s,p.c);
    setCtas(p);
    /* 追従バーは、色を押しただけでは購入の文言にしない。
       上のスウォッチを押した時点では構成（セット）が決まっておらず、
       「そのカラーを購入する」文言が一瞬出てしまうため。
       サイズだけ選んだときと同じ「サイズと色を選ぶ」の状態のままにしておき、
       構成まで決まったらカート側（sbarPick）が purchase の文言に差し替える */
    var cMin=basePrice(p);   /* そのサイズ×カラーで買える最安 */
    var cSrc=(p.room||(room?room.src:''));
    window.sbarFill=function(){
      var th=document.getElementById('sbar-th');
      if(th){ if(cSrc){ th.src=cSrc; th.alt=p.s+' '+p.c; th.hidden=false; } else th.hidden=true; }
      if(sbarT) sbarT.innerHTML='<b>'+p.s+' '+p.c+'</b>'+(cMin===null?'':yen(cMin)+'から ／ ')+'送料無料';
      if(sbarA){ sbarA.textContent=sbarA0; sbarA.setAttribute('href',sbarH0); sbarA.onclick=null; }
    };
    if(window.__sbarApply) window.__sbarApply();
  }
  function render(size){
    var items=CART.p.filter(function(p){ return p.s===size; });
    var by={}; items.forEach(function(p){ by[p.c]=p; });
    chips.innerHTML='';
    FN.forEach(function(f){
     var any=f[3].some(function(g){ return listOf(g).some(function(c){ return by[c]; }); });
     if(!any) return;
     f[3].forEach(function(g){
      var cols=listOf(g).filter(function(c){ return by[c]; });
      if(!cols.length) return;
      var h=document.createElement('p'); h.className='mat';
      h.innerHTML='<span class="l"><b>'+g[0]+'</b></span>'+
        '<s>'+g[2]+'</s><i><span aria-hidden="true">'+f[0]+'</span>'+g[1]+'</i>';
      chips.appendChild(h);
      var row=document.createElement('div'); row.className='row';
      cols.forEach(function(c){
        /* スウォッチ画像。LPに焼いてある sw-<色名> が先。無ければ商品データの
           生地アップ sw（色のメタオブジェクト custom.loosy_color の image）、
           それも無ければカラーチップ chip（custom.loosy_color_detail_image）を使う。
           ★これが無いと、新色は焼き込みを足すまでチップごと無言で消える。
           ★chip を直に出すと「自然光／蛍光灯／暖色灯」の3分割カットがそのまま縮むので、
             白フチと文字が入って何色か読めない（2026/10/07 シェニール4色で発生）。
             sw を先に見るので、新色でも焼き込み無しで生地アップが出る。
             どれも無い色は出さない（何色か分からないまま選ばせない） */
        var src=document.getElementById(swId(c));
        var swurl=src?src.src:((by[c]&&(by[c].sw||by[c].chip))||'');
        if(!swurl) return;
        /* その色の構成がひとつも買えないなら、押せないようにして「入荷待ち」と出す */
        var soldout=!((by[c].v||[]).some(function(v){ return v[3]!==0 }));
        var b=document.createElement('button');
        b.type='button'; b.dataset.c=c; b.setAttribute('aria-pressed','false');
        b.setAttribute('aria-label',c+(soldout?'（入荷待ち）':'')); b.title=c;
        if(soldout){ b.className='soldout'; b.disabled=true; }
        var im=document.createElement('img'); im.loading='lazy'; im.src=swurl; im.alt=c+' の生地';
        var nm=document.createElement('em'); nm.innerHTML=c+(soldout?'<br>入荷待ち':'');
        b.appendChild(im); b.appendChild(nm);
        // click より先に発火するので、指を置いた時点で読み込みを始められる。
        // これが無いと、押してから画像が届くまで前の色の写真が残る
        b.addEventListener('pointerdown',function(){
          var u=by[c]&&by[c].room; if(u){ var pre=new Image(); pre.src=u; }
        },{passive:true});
        b.addEventListener('click',function(){ select(by[c]); });
        row.appendChild(b);
      });
      chips.appendChild(row);
     });
    });
    showRoom(size,items);
  }
  // 画像差し替えで生地チップの元画像が変わったら、この関数で描き直す
  window.__rerenderPicker=function(){
    var on=tabs.filter(function(x){return x.classList.contains('on')})[0]||tabs[0];
    render(on.dataset.size||on.textContent.trim().replace(/\d+色$/,''));
  };
  // タブに、そのサイズで実際に買える色数を出す
  tabs.forEach(function(t){
    var size=t.dataset.size || t.textContent.trim();
    t.dataset.size=size;
    var n=CART.p.filter(function(p){ return p.s===size; }).length;
    t.innerHTML=size+'<small>'+n+'色</small>';
    t.setAttribute('role','button'); t.setAttribute('tabindex','0');
    t.addEventListener('click',function(){
      tabs.forEach(function(x){ x.classList.remove('on'); });
      t.classList.add('on');
      render(size);
    });
  });
  render('1人掛け');
});

// --- FAQ の後半を開く
(function(){
  var fb=document.getElementById('faqbtn'), fm=document.getElementById('faqmore');
  if(!fb||!fm) return;
  var n=fm.querySelectorAll('details').length;
  fb.textContent='＋ 残り'+n+'件の質問を見る';
  fb.addEventListener('click',function(){
    var open=fm.hidden;
    fm.hidden=!open;
    fb.textContent=open?'− 質問を閉じる':'＋ 残り'+n+'件の質問を見る';
  });
})();

// --- 編集中はリンクを踏まない
document.addEventListener('click',function(ev){
  if(!b.classList.contains('editing')) return;
  var a=ev.target&&ev.target.closest?ev.target.closest('a[href]'):null;
  if(a && document.querySelector('.stage').contains(a)) ev.preventDefault();
},true);

// --- 書き出し
var expbtn=document.getElementById('expbtn'), expwrap=document.getElementById('expwrap'),
    exptext=document.getElementById('exptext');
function plain(h){ var d=document.createElement('div'); d.innerHTML=h;
  return (d.textContent||'').replace(/\s+/g,' ').trim(); }
expbtn.addEventListener('click',function(){
  var L=['# LOOSY LP モック 変更内容','取得日時: '+new Date().toLocaleString('ja-JP'),''];
  var order=Array.prototype.map.call(document.querySelectorAll('.swrap'),function(x){return x});
  var moved=order.map(function(x){return x.id}).join(',')!==WRAPS.map(function(x){return x.id}).join(',');
  L.push('## セクションの並び'+(moved?'（変更あり）':'（変更なし）'));
  order.forEach(function(x,i){
    L.push(('  '+(i+1)).slice(-3)+'. '+(x.dataset.name||x.id)+(x.classList.contains('off')?'   ← 非表示':''));
  });
  L.push('');
  var ch=EDN.filter(function(el){ return el.innerHTML!==el.dataset.orig; });
  var live={}; EDN.forEach(function(el){live[el.dataset.t]=1});
  var orphan=Object.keys(state.text).filter(function(k){return !live[k]});
  if(orphan.length) L.push('※ 原文が更新されたため外れた編集が '+orphan.length+' 件あります');
  L.push('## 文言の変更（'+ch.length+'件）');
  if(!ch.length) L.push('  なし');
  ch.forEach(function(el){
    L.push('- 変更前: '+plain(el.dataset.orig));
    L.push('  変更後: '+plain(el.innerHTML));
  });
  var im=state.img||{}, iks=Object.keys(im);
  L.push('');
  L.push('## 画像の差し替え（'+iks.length+'件）');
  if(!iks.length) L.push('  なし');
  iks.forEach(function(k){
    var r=im[k];
    var line='- '+k+' : '+(r.t==='url'?('URL '+r.v):('アップロード '+(r.n||'')));
    if(r.pos&&r.pos!=='50% 50%'){
      var el=document.querySelector('[data-k="'+k+'"]');
      var fr=(el&&el.dataset.frame&&el.dataset.frame!=='css')?el.dataset.frame:'';
      line+=' ／ 切り抜き '+r.pos+(fr?('・枠 '+fr):'');
    }
    L.push(line);
  });
  exptext.value=L.join('\n');
  b.classList.add('exporting');
});
document.getElementById('expclose').addEventListener('click',function(){b.classList.remove('exporting')});
document.getElementById('expcopy').addEventListener('click',function(){
  exptext.select();
  try{ document.execCommand('copy'); this.textContent='コピーしました'; var self=this;
       setTimeout(function(){self.textContent='コピー'},1500); }catch(e){}
});
var sbar=document.getElementById('sbar'),gate=document.getElementById('pricegate');
/* 追従バーは3段階。
   ① calm  FVを抜けてからS8が見えるまで … 安心の帯。価格へは飛ばさない。
      現行LPの「LOOSY全ラインナップを見る」は上部から価格へ飛べてしまい、
      「価値を理解してから価格」という設計が崩れる。ここでは安心の掲示を常時出し、
      押し先はS1（安心3本柱）にする。
   ② none  S8が視界に入っている間 … 色とサイズを選んでいる最中。
      選択中は .pvbar が担当するので、下から重ねない（指示：選択作業中はバーを出さない）。
   ③ buy   価格を通過したあと … 従来どおりの購入の帯。選択済みなら色と金額を出す。 */
/* 安心の帯の文言・リンク先・色は、ページのメタフィールドから差し替えられる。
   本番では loosy-lp2-data.liquid が window.LPBAR に入れる（管理画面のページ編集で変更可）。
   入っていなければ下の既定値を使うので、モックでもそのまま動く。
   文字数は短くする。読んでいる最中ずっと出ているので、2行より1行のほうが邪魔にならない */
var _LB = (window.LPBAR||{});
var CALM_T = _LB.text || '<b>全26色</b>送料無料/3つの安心';
var CALM_A = _LB.cta  || 'サイズと色を選ぶ';
var CALM_H = _LB.href || '#s8';
if(_LB.color){
  try{ document.documentElement.style.setProperty('--calmbar', _LB.color); }catch(e){}
}
var sbarMode='';
/* 購入の帯の既定値。B案は色を選んだ時点で sbarFill が入るが、
   C案（商品一覧）には選択機能が無く sbarFill が定義されない。
   その場合に安心の帯の文言が黒い帯へ残らないよう、初期値へ戻す */
var sbarT0=(function(){var e=document.querySelector('#sbar .t');return e?e.innerHTML:''})();
var sbarA0d=(function(){var a=document.querySelector('#sbar a');return a?{t:a.textContent,h:a.getAttribute('href')}:null})();
function sbarSync(){
  if(!sbar||!gate)return;
  var s0=document.getElementById('sec-s0'), s8=document.getElementById('sec-s8');
  /* 下の購入バーを出す境界。
     従来は #pricegate（カート末尾の約300px下）まで待っていたので、
     カート欄を抜けたあとしばらく何も追従しない区間ができていた。
     カート欄そのものを通り過ぎた時点で出す。カート欄の中では今までどおり出さない
     （選択作業の画面にバーを重ねない）*/
  var cart=document.getElementById('cartblock');
  var crect=(cart && !cart.hidden) ? cart.getBoundingClientRect() : null;
  var cartDone=!!(crect && crect.bottom<0);
  var past=cartDone||gate.getBoundingClientRect().bottom<0;
  var afterFV=!s0||s0.getBoundingClientRect().bottom<0;
  var nearS8=s8&&s8.getBoundingClientRect().top<window.innerHeight;
  /* ★カートに中身があるあいだは、スクロール位置に関係なく購入の帯を出す。
     カート欄（#cartblock）は色を選ぶまで隠れているので、戻ってきた直後は
     画面に戻り道が1つも無くなる。帯にその役目を持たせる。
     ただしカート欄が画面に出ているあいだは出さない（同じ戻り道が2つになる） */
  var cartOnScreen=!!(crect && crect.top<window.innerHeight && crect.bottom>0);
  var inCart=!!(window.__cdCart && window.__cdCart.n) && !cartOnScreen;
  var mode = (past||inCart) ? 'buy' : (afterFV && !nearS8 ? 'calm' : 'none');
  if(mode!==sbarMode){
    sbarMode=mode;
    sbar.classList.toggle('calm',mode==='calm');
    if(mode==='calm'){
      var th0=document.getElementById('sbar-th'); if(th0) th0.hidden=true;
      var t=sbar.querySelector('.t'), a=sbar.querySelector('a');
      if(t) t.innerHTML=CALM_T;
      if(a){ a.textContent=CALM_A; a.setAttribute('href',CALM_H); a.onclick=null; }
    }else if(mode==='buy'){
      if(typeof sbarFill==='function'){ sbarFill(); }   // 選択状態に応じて文言を戻す
      else{                                             // 選択機能が無い版（C案）
        var t0=sbar.querySelector('.t'), a0=sbar.querySelector('a');
        if(t0) t0.innerHTML=sbarT0;
        if(a0&&sbarA0d){ a0.textContent=sbarA0d.t; a0.setAttribute('href',sbarA0d.h); a0.onclick=null; }
      }
    }
  }
  sbar.hidden=(mode==='none'); b.classList.toggle('sbar-on',mode!=='none');
  // 下に隠れる分を実測で確保する。決め打ちだと安心の帯（2行）で末尾が隠れる
  document.documentElement.style.setProperty('--sbarh',
    (mode==='none' ? 0 : sbar.offsetHeight) + 'px');
}
window.addEventListener('scroll',sbarSync,{passive:true});
window.addEventListener('resize',sbarSync);
sbarSync();
/* 追従バーの中身を差し替えたあとに呼ぶ。購入の帯が出ているときだけ描き直す。
   安心の帯（calm）が出ているあいだに sbarFill を当てると、安心の文言が
   購入の文言で上書きされてしまう */
window.__sbarApply=function(){ if(sbarMode==='buy'&&typeof window.sbarFill==='function') window.sbarFill(); };
/* カートの中身が分かった時点で帯を出し直す（読み込み直後は __cdCart がまだ空のため） */
window.__sbarSync=sbarSync;
var pp=document.getElementById('pp');
pp.addEventListener('click',function(){
  var on=b.classList.toggle('props');
  pp.textContent=on?'提案を隠す':'提案を表示';
  pp.setAttribute('aria-pressed',on?'true':'false');
});

;

(function(){
 var SIZES=['ミニ','1人掛け','2人掛け'];
 var POP=['Ivory','Green','Navy','Charcoal','Blood Orange','Mint'];
 var st={s:null,c:null,t:null,add:{},open:false,covc:null,covopen:false};
 var $=function(i){return document.getElementById(i)};
 var yen=function(n){return '¥'+n.toLocaleString('ja-JP')};
 var key=function(c){return 'c-'+c.toLowerCase().replace(/ /g,'-')};
 function popsort(a,b){var ia=POP.indexOf(a),ib=POP.indexOf(b);return (ia<0?99:ia)-(ib<0?99:ib)||a.localeCompare(b)}
 function minPrice(sz){var m=Infinity;CART.p.forEach(function(x){if(x.s===sz)x.v.forEach(function(v){if(v[3]!==0&&v[2]<m)m=v[2]})});return m}
 /* チップの中の金額。セール中だけ 通常価格（打ち消し）＋色付きの販売価格 になる。
    セールでないときは今までどおり素の金額を返す（見た目を変えない） */
 function priceChip(now,was){ return salePriceChip(now,was) }
 function btn(cls,label,on,cb){var b=document.createElement('button');b.type='button';b.className=cls;
   b.innerHTML=label;b.setAttribute('aria-pressed',on?'true':'false');b.onclick=cb;return b}
 /* imgUrl を渡すとその画像を使う。渡さなければ今までどおり色名から引く。
    替えカバーはサイズごとに写真が違うので、必ず渡すこと。
    色名だけで引くと、2人掛け・ミニでも1人掛けの写真が出る */
 function thumb(color,name,sub,on,cb,imgUrl){
   var b=btn('copt','',on,cb);
   var img=document.createElement('img'),src=imgUrl?null:document.getElementById(key(color));
   img.loading='lazy';img.src=imgUrl||(src?src.src:'');img.alt=color;
   var sp=document.createElement('span');sp.innerHTML=name+(sub?'<br>'+sub:'');
   b.appendChild(img);b.appendChild(sp);return b}
 /* 在庫。0 のときだけ在庫切れとみなす。データに在庫が入っていない古い形（undefined）は
    在庫ありのまま扱う。商品ページの .variant-pill.is-disabled と同じ見せ方にする
    （薄くして押せなくし、値段の代わりに「入荷待ち」と出す） */
 function inStock(f){ return f!==0 }
 function pAvail(p){ return !!(p&&p.v&&p.v.some(function(v){return inStock(v[3])})) }
 function cur(){return CART.p.find(function(x){return x.s===st.s&&x.c===st.c})}
 /* 在庫切れの構成が選ばれている状態（在庫が切れたあとの復元など）は「未選択」として返す。
    ここで止めておけば、金額・オプション・カートボタンまで全部まとめて正しくなる */
 function curV(){var p=cur();var v=p&&p.v.find(function(x){return x[0]===st.t});
   return (v&&inStock(v[3]))?v:undefined}
 function covList(){ // 選択中サイズ・構成で買える替えカバーの色
   var v=curV(); if(!v||!CART.cov[st.s])return [];
   var m=CART.cov[st.s], out=[];
   Object.keys(m).forEach(function(c){ if(m[c][v[1]]) out.push([c,m[c][v[1]][0],m[c][v[1]][1],m[c][v[1]][2],m[c][v[1]][3],m[c][v[1]][4],m[c][v[1]][5]||0]) });
   out.sort(function(a,b){return popsort(a[0],b[0])});
   return out}

 function renderSize(){var w=$('c-size');w.innerHTML='';
   SIZES.forEach(function(sz){ if(!CART.p.some(function(x){return x.s===sz}))return;
     var mp=minPrice(sz);
     w.appendChild(btn('opt',sz+'<small>'+(isFinite(mp)?yen(mp)+'から':'入荷待ち')+'</small>',st.s===sz,
       function(){st.s=sz;st.c=null;st.t=null;st.add={};st.open=false;st.covc=null;st.covopen=false;render()}));});}
 function renderColor(){var w=$('c-color'),mw=$('c-more');w.innerHTML='';mw.innerHTML='';
   if(!st.s){$('c-cnum').textContent='';return}
   var list=CART.p.filter(function(x){return x.s===st.s});
   list.sort(function(a,b){return popsort(a.c,b.c)});
   var shown=st.open?list:list.slice(0,6);
   if(st.c&&shown.every(function(x){return x.c!==st.c})){st.open=true;shown=list}
   $('c-cnum').textContent=st.open?list.length+'色':'人気6色 / 全'+list.length+'色';
   shown.forEach(function(x){
     var out=!pAvail(x);
     var t=thumb(x.c,x.c,out?'入荷待ち':'',!out&&st.c===x.c,
       out?null:function(){st.c=x.c;st.t=null;st.add={};st.covc=null;render()});
     if(out){ t.disabled=true; t.className+=' soldout'; }
     w.appendChild(t)});
   if(!st.open&&list.length>6){var m=document.createElement('button');m.type='button';m.className='more';
     m.textContent='＋ 残り'+(list.length-6)+'色を見る';m.onclick=function(){st.open=true;render()};mw.appendChild(m)}}
 function renderType(){var w=$('c-type');w.innerHTML='';var p=cur();if(!p)return;
   var lb=$('c-typelb');
   if(lb){
     var sw=document.getElementById('sw-'+st.c.toLowerCase().replace(/\s+/g,'-'));
     lb.innerHTML=(sw?'<span class="sw" style="background-image:url('+sw.getAttribute('src')+')"></span>':'')+
       st.s+' <b>'+st.c+'</b> のセットを選ぶ';
   }
   p.v.forEach(function(v){
     // 商品ページが「ソファ+オットマン」に付けている人気バッジを、同じ位置で再現する
     var no1=(v[1]==='ソファ+オットマン')?'<span class="no1">人気セット</span>':'';
     var out=!inStock(v[3]);
     var b=btn('opt'+(out?' soldout':''),
       v[1]+no1+'<small>'+(out?'入荷待ち':priceChip(v[2],v[5]))+'</small>',
       !out&&st.t===v[0],
       out?null:function(){st.t=v[0];st.covc=null;render()});
     if(out){ b.disabled=true; b.setAttribute('aria-disabled','true'); }
     w.appendChild(b)});}

 function renderAdd(){
   var wrap=$('c-addwrap'),w=$('c-adds'),v=curV();
   w.innerHTML='';
   if(!v){wrap.hidden=true;return}
   wrap.hidden=false;
   var covs=covList();
   // 1) 防水インナーカバー（バナーの真下に置く）
   var p=cur();
   if(p.wp){
     var wpOut=!inStock(p.wp[3]);
     if(wpOut) st.add.wp=false;
     var l2=document.createElement('label');l2.className='add'+(st.add.wp?' on':'')+(wpOut?' soldout':'');
     var c2=document.createElement('input');c2.type='checkbox';c2.checked=!!st.add.wp;
     c2.disabled=wpOut;
     c2.onchange=function(){st.add.wp=c2.checked;render()};
     var m2d=document.createElement('div');
     m2d.innerHTML='<b>防水インナーカバー</b><span>液体の浸透を防ぐ・洗濯OK。ペットや小さなお子さまのいるご家庭に</span>';
     var p2=document.createElement('em');p2.textContent=wpOut?'入荷待ち':'+'+yen(p.wp[1]);
     l2.appendChild(c2);l2.appendChild(m2d);l2.appendChild(p2);w.appendChild(l2);
   }
   // 2) 替えカバー（色を選べる）
   if(covs.length){
     var covIn=covs.filter(function(x){return inStock(x[4])});
     // 在庫切れの色が選ばれたままにならないようにする
     if(st.covc && !covs.some(function(x){return x[0]===st.covc&&inStock(x[4])})) st.covc=null;
     if(!covIn.length) st.add.cov=false;
     var picked=st.covc&&covs.find(function(x){return x[0]===st.covc});
     var box=document.createElement('div');
     var l=document.createElement('label');l.className='add'+(st.add.cov?' on':'')+(covIn.length?'':' soldout');
     var cb=document.createElement('input');cb.type='checkbox';cb.checked=!!st.add.cov;
     cb.disabled=!covIn.length;
     cb.onchange=function(){
       if(cb.checked){ if(!st.covc){var same=covIn.find(function(x){return x[0]===st.c}); st.covc=same?same[0]:(covIn[0]&&covIn[0][0])} st.add.cov=!!st.covc }
       else { st.add.cov=false }
       render()};
     var mid=document.createElement('div');
     mid.innerHTML='<b>替えカバー'+(v?'（'+v[1]+'用）':'')+'</b><span>'+
       (st.add.cov&&picked?'選択中：'+picked[0]:'いま選んでいる構成に合うセットです。色はソファと違う色でもOK')+'</span>';
     var pz=document.createElement('em');
     pz.textContent=!covIn.length ? '入荷待ち'
       : ((st.add.cov&&picked) ? '+'+yen(picked[2])
          : '+'+yen(Math.min.apply(null,covIn.map(function(x){return x[2]})))+'〜');
     l.appendChild(cb);l.appendChild(mid);l.appendChild(pz);box.appendChild(l);
     if(st.add.cov){
       var pick=document.createElement('div');pick.className='covpick';
       var h=document.createElement('div');h.className='h';
       h.innerHTML='<b>カバーの色</b><span>'+(st.covopen?covs.length+'色':'人気6色 / 全'+covs.length+'色')+'</span>';
       pick.appendChild(h);
       var g=document.createElement('div');g.className='copts';
       var shown=st.covopen?covs:covs.slice(0,6);
       if(st.covc&&shown.every(function(x){return x[0]!==st.covc})){st.covopen=true;shown=covs}
       shown.forEach(function(x){
         var out=!inStock(x[4]);
         var t=thumb(x[0],x[0],out?'入荷待ち':yen(x[2]),!out&&st.covc===x[0],
           out?null:function(){st.covc=x[0];render()}, x[5]);
         if(out){ t.disabled=true; t.className+=' soldout'; }
         g.appendChild(t)});
       pick.appendChild(g);
       if(!st.covopen&&covs.length>6){var m2=document.createElement('button');m2.type='button';m2.className='more';
         m2.textContent='＋ 残り'+(covs.length-6)+'色を見る';m2.onclick=function(){st.covopen=true;render()};pick.appendChild(m2)}
       box.appendChild(pick);
     }
     w.appendChild(box);
   }
   // 3) 補充ビーズ
   var bdOut=!inStock(CART.beads[3]);
   if(bdOut) st.add.beads=false;
   var l3=document.createElement('label');l3.className='add'+(st.add.beads?' on':'')+(bdOut?' soldout':'');
   var c3=document.createElement('input');c3.type='checkbox';c3.checked=!!st.add.beads;
   c3.disabled=bdOut;
   c3.onchange=function(){st.add.beads=c3.checked;render()};
   var m3=document.createElement('div');
   m3.innerHTML='<b>補充ビーズ 300g</b><span>へたってきたら足して、座り心地を戻せます</span>';
   var p3=document.createElement('em');p3.textContent=bdOut?'入荷待ち':'+'+yen(CART.beads[1]);
   l3.appendChild(c3);l3.appendChild(m3);l3.appendChild(p3);w.appendChild(l3);}

 /* 追従バーの中身。構成（セット）まで決まってはじめて購入の文言にする。
    押すとカートの欄へ戻る（その場では入れない）。__cartPick は同じサイズ・色なら
    作り直さないので、選んだオプションはそのまま残る */
 function sbarPick(v,list){
   var t=document.querySelector('#sbar .t'), a=document.querySelector('#sbar a');
   if(!t||!a) return;
   var th=document.getElementById('sbar-th');
   var pvi=document.getElementById('pv-img');
   var src=(pvi&&pvi.getAttribute('src'))||'';
   function thumb(on){ if(!th) return;
     if(on&&src){ th.src=src; th.alt=st.s+' '+(st.c||''); th.hidden=false; } else th.hidden=true; }
   if(v){
     window.sbarFill=function(){
       thumb(true);
       /* 出すのは選んだソファ（バリアント）の値段だけ。オプションを足すたびに
          数字が動くと、何の値段なのかが分からなくなる。カート上のバー（#c-pick）と
          写真バーも同じくバリアントの値段なので、これで3つとも揃う。
          合計はカートの欄が持つ。オプションがあるときは点数を添えて、
          ここの数字が総額ではないことが分かるようにする */
       var nopt=(list?list.length:1)-1;
       /* オプションがあるときは「送料無料」を落とす。3つ並べると長い色名で
          帯が109pxまで伸びる。送料無料は安心の帯とカートの欄に出ている */
       t.innerHTML='<b>'+st.s+' '+st.c+'</b>'+yen(v[2])
         +(nopt>0?' ＋オプション'+nopt+'点':' ／ 送料無料');
       a.textContent='購入に進む'; a.setAttribute('href','#cartblock');
       a.onclick=function(e){ if(!window.__cartPick) return; e.preventDefault();
         window.__cartPick(st.s,st.c); };
     };
   } else if(st.s){
     /* 構成がまだなら「¥◯◯から」。色まで選んでいれば その色の最安、
        サイズだけならそのサイズの最安。
        basePrice() は上のピッカー側の関数でここからは見えないので自前で出す */
     var p0=cur(), mp=null;
     if(p0) p0.v.forEach(function(v){ if(inStock(v[3])&&(mp===null||v[2]<mp)) mp=v[2] });
     if(mp===null){ var mz=minPrice(st.s); mp=isFinite(mz)?mz:null; }
     var nm=st.s+(st.c?' '+st.c:'');
     window.sbarFill=function(){
       thumb(!!st.c);
       t.innerHTML='<b>'+nm+'</b>'+((mp!==null&&isFinite(mp))?yen(mp)+'から ／ ':'')+'送料無料';
       a.textContent='サイズと色を選ぶ'; a.setAttribute('href','#s8'); a.onclick=null;
     };
   } else { return }
   if(window.__sbarApply) window.__sbarApply();
 }

 /* 発送予定日。出典は商品ページと同じバリアントメタフィールド custom.delivery_date。
    出すのはソファ本体の分だけ。オプションは納期が別なので注記に逃がす */
 function shipSync(v,list){
   var ship=$('c-ship'); if(!ship) return;
   ship.hidden=false;
   var line=ship.querySelector('.l'), bx=ship.querySelector('.l b'),
       lb=ship.querySelector('.l span'), opt=$('c-shipopt');
   var d=(v&&v[4])||'';
   if(line) line.hidden=!d;
   if(bx&&d) bx.textContent=d;
   var hasOpt=!!(d&&list&&list.length>1);
   if(lb) lb.textContent=hasOpt?'ソファの発送予定日':'発送予定日';
   if(opt) opt.hidden=!hasOpt;
 }

 function items(){
   var v=curV(); if(!v)return null;
   if(!inStock(v[3])) return null;   /* 在庫切れの構成は返さない */
   var list=[[v[0],st.s+' '+st.c+' '+v[1],v[2],v[4]||'',v[5]||0]];
   if(st.add.cov&&st.covc){var e=covList().find(function(x){return x[0]===st.covc&&inStock(x[4])});
     if(e)list.push([e[1],'替えカバー '+e[0],e[2],e[3]||'',e[6]||0])}
   var p=cur();
   if(st.add.wp&&p.wp&&inStock(p.wp[3]))list.push([p.wp[0],'防水インナーカバー',p.wp[1],p.wp[2]||'',p.wp[4]||0]);
   if(st.add.beads&&inStock(CART.beads[3]))list.push([CART.beads[0],'補充ビーズ 300g',CART.beads[1],CART.beads[2]||'',CART.beads[4]||0]);
   return list}

 /*CDJS:START ─ カートに入れたあと（ドロワー）─────────────────────
    以前はここで /cart へ飛ばしていた。飛び先はテーマのカート画面で、
    LPが出している保証・決済・納期が無く、ヘッダーとおすすめ商品の付いた別ページになる。
    商品ページと旧LPは同じ場面でテーマのカートドロワー
    （snippets/header-cart-drawer.liquid）を出していて、そこには安心バナー
    （30日間返金保証／送料無料／製品保証1年）と決済アイコンが入っている。
    このLPは theme.liquid を通らないのでテーマのドロワーは使えない。同じものをここで持つ。
    ページを移らないだけで、AddToCart は POST /cart/add.js が出したまま＝計測は変わらない。

    ★このブロックは他のLPへそのまま移せるように自己完結させてある。
      外から使うのは window.__cdOn / __cdAfterAdd / __cdOpenLocal / __cdCart / __cdGoHref だけ。
      中で使う外のものは CART（商品データ）と paidyShow（あれば）だけ。 */
 (function(){
   var $=function(i){return document.getElementById(i)};
   var yen=function(n){return '¥'+Number(n||0).toLocaleString('ja-JP')};
   var LIVE=location.hostname.indexOf('littlerooms')>=0;
   /* 出す・出さないの切り替え。**既定はドロワー**（2026/09/18 きえ判断で全員に出す）。
      ・URL に ?cd=0 … そのアクセスだけ元の動き（/cart へ遷移）。?cd=1 でドロワー
        一度指定したら、そのタブのあいだは同じ挙動を保つ（読み込み直しで混ざらない）
      ・ページのメタフィールド custom.lp_cart_drawer を false … そのページだけ元の動き
        （未設定＝ドロワー。ページ単位で止めるための逃げ道） */
   var ON=(function(){
     var m=/[?&]cd=([01])/.exec(location.search||'');
     try{
       if(m){ sessionStorage.setItem('lp_cd',m[1]); return m[1]==='1' }
       var s=sessionStorage.getItem('lp_cd');
       if(s!==null) return s==='1';
     }catch(e){ if(m) return m[1]==='1' }
     if(window.LPCD===false) return false;
     return true })();
   var busy=0, NAMES=null, TERM=null, DATA=null;
   var BACK=false;   /* ボタンが「カートに戻る」になっているか */
   var KEEP=false;   /* 「買い物を続ける」を押した＝続けて選びたい */
   function esc(s){ return String(s==null?'':s).replace(/[<>&"]/g,function(c){
     return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c]}) }
   function thumb(u){ if(!u) return '';
     if(u.indexOf('data:')===0) return u;
     return u+(u.indexOf('?')<0?'?':'&')+'width=160' }
   /* バリアントID → 「商品名」と「色／セット」と body（＝ソファ本体か）。
      色は商品名の中に入っている（色ごとに別商品）ので、名前を切らずに CART から引き直す。
      CART に無いもの（他のページで入れた商品など）は Shopify の名前をそのまま使う */
   /* 掲出中のカウントダウンバーがあるときだけ、セールの表記を出す。
      商品側の通常価格を外し忘れても、バーの終了日時でこちらは止まる。
      ★バーは position:fixed なので offsetParent は必ず null になる。
        クーポンの coupon() と同じ書き方にすると常に「出ていない」になる */
   function saleOn(){
     var b=document.querySelector('[data-lp2cd]');
     return !!(b && !b.hidden && (b.offsetWidth||b.offsetHeight||b.getClientRects().length)) }
   function names(){ if(NAMES) return NAMES; var m={};
     try{
       var C=window.CART||{};
       (C.p||[]).forEach(function(p){
         /* body=本体。保証（返金・製品保証）は本体を買った人が対象なので、
            オプションだけのカートでは保証を出さない */
         /* was=通常価格（セール中でなければ 0）。合計の上に出す「通常価格」を
            ここから組む。商品行には出さない（同じ値引きを2か所で言わない） */
         (p.v||[]).forEach(function(v){ m[v[0]]={n:'LOOSY ビーズソファ '+p.s, o:p.c+' ／ '+v[1], body:true, was:v[5]||0} });
         if(p.wp) m[p.wp[0]]={n:'LOOSY 防水インナーカバー '+p.s, o:'', was:p.wp[4]||0};
       });
       Object.keys(C.cov||{}).forEach(function(sz){ var mm=C.cov[sz];
         Object.keys(mm).forEach(function(c){ Object.keys(mm[c]).forEach(function(set){
           m[mm[c][set][0]]={n:'LOOSY 替えカバー '+sz, o:c+' ／ '+set, was:mm[c][set][5]||0} }) }) });
       if(C.beads) m[C.beads[0]]={n:'LOOSY 補充ビーズ 300g', o:'', was:C.beads[4]||0};
     }catch(e){}
     NAMES=m; return m }
   /* Shopifyのカート（/cart.js）を、ドロワーが読む形にそろえる。
      金額は cart.js が最小単位（＝円の100倍）で返すので100で割る。
      total_price は「いま払う額」。お会計でクーポンを当てたあとはカートにも割引が乗るので、
      割引前（items_subtotal_price）と割引額も一緒に持つ（二重に引かないため） */
   function fromCart(c){ var nm=names(), wasSub=0;
     var rows=(c.items||[]).map(function(it){
       var pr=it.properties||{}, f=nm[it.id]||null, q=it.quantity||1;
       /* 通常価格が無い品は「値引きしていない」＝割引前の行計をそのまま足す。
          ここで販売価格を足してしまうと、オプションを入れるたびに引いた額が増える */
       var orig=Math.round((it.original_line_price||it.final_line_price||0)/100);
       var lw=(f&&f.was) ? f.was*q : orig;
       wasSub += lw;
       return {key:it.key, id:it.id, handle:it.handle||'', img:it.image||'', body:!!(f&&f.body),
         name:f?f.n:String(it.product_title),
         opt:f?f.o:((it.variant_title&&it.variant_title!=='Default Title')?it.variant_title:''),
         qty:q, date:pr['発送予定日']||'',
         unit:Math.round((it.final_price||0)/100),
         /* was=この行の通常価格（×個数）。行には通常価格を出し、値引きは下の段で1回だけ引く */
         was:lw, unitWas:(f&&f.was)?f.was:Math.round((it.original_price||it.final_price||0)/100),
         price:Math.round((it.final_line_price||0)/100)} });
     return {total:Math.round((c.total_price||0)/100), count:c.item_count||0,
       sub:Math.round((c.items_subtotal_price||c.total_price||0)/100),
       disc:Math.round((c.total_discount||0)/100),
       wasSub:wasSub, items:rows} }
   /* モック（本番以外）用。ネットに出ずに、いま選んでいる中身でそのまま開く */
   function fromLocal(list,img){ var nm=names(), tot=0, wasSub=0;
     list=list||[]; list.forEach(function(x){ tot+=x[2]; wasSub+=(x[4]&&x[4]>x[2])?x[4]:x[2] });
     return {total:tot, sub:tot, disc:0, count:list.length, wasSub:wasSub, items:list.map(function(x,i){
       var f=nm[x[0]]||null;
       return {key:'', id:x[0], handle:f?f.n:'', img:i?'':(img||''), name:f?f.n:x[1], opt:f?f.o:'',
         body:!!(f&&f.body), qty:1, date:x[3]||'', unit:x[2], price:x[2],
         was:(x[4]&&x[4]>x[2])?x[4]:x[2], unitWas:(x[4]&&x[4]>x[2])?x[4]:x[2]}})} }
   /* 掲出中のクーポン。セクションが出ているときだけ拾う。
      期間が終わるとセクションごと消えるので、この行も お会計のコードも自動で消える */
   function coupon(){
     var el=document.querySelector('[data-lp2cp-code]');
     if(!el||!el.offsetParent) return null;
     var root=el.closest?el.closest('[data-lp2cp]'):null;
     var num=function(a){ return root?(parseInt(root.getAttribute(a),10)||0):0 };
     return {code:(el.textContent||'').trim(), amount:num('data-cp-amount'), min:num('data-cp-min')} }
   /* 保証の条件。本文S13の規約（#terms-refund / #terms-warranty）から中身をもらう。
      2か所に同じ文面を書くと必ずずれるので、原文は本文の1か所に置いたままにする */
   function termHTML(kind){
     if(kind==='ship') return '<dl><dt>送料</dt><dd>全国無料。沖縄・離島のみ別途追加送料がかかります（お会計時に表示）</dd></dl>';
     var src=$(kind==='refund'?'terms-refund':'terms-warranty');
     if(!src) return '';
     var out='', dl=src.querySelector('dl'), a=src.querySelector('a');
     if(dl) out+=dl.outerHTML;
     if(a) out+='<a href="'+esc(a.getAttribute('href'))+'">'+esc(a.textContent)+'</a>';
     return out }
   function termShow(kind){
     var p=$('cd-term'); if(!p) return;
     var btns=document.querySelectorAll('[data-cdterm]'), i;
     if(!kind||kind===TERM){ TERM=null; p.hidden=true; p.innerHTML='';
       for(i=0;i<btns.length;i++) btns[i].setAttribute('aria-expanded','false'); return }
     var html=termHTML(kind); if(!html) return;
     var ttl={refund:'30日間返金保証の条件', warranty:'1年 製品保証の条件', ship:'送料について'}[kind]||'条件';
     TERM=kind;
     p.innerHTML='<div class="th"><b>'+ttl+'</b>'+
       '<button type="button" class="tx" data-cdterm-close="1">閉じる ✕</button></div>'+html;
     p.hidden=false;
     for(i=0;i<btns.length;i++)
       btns[i].setAttribute('aria-expanded', btns[i].getAttribute('data-cdterm')===kind?'true':'false') }
   /* 数量の変更・削除。Shopifyのカートに当ててから、返ってきた中身で描き直す。
      行の指定は key（同じバリアントでも納期が違えば別の行になるため、
      バリアントIDだと当たらないことがある） */
   function change(key,q){
     if(busy||!key||!LIVE) return;
     busy=1; var box=document.querySelector('.cd');
     if(box) box.setAttribute('aria-busy','true');
     function done(){ busy=0; if(box) box.removeAttribute('aria-busy') }
     fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
       body:JSON.stringify({id:key,quantity:q})})
       .then(function(r){ if(!r.ok) throw 0; return r.json() })
       .then(function(c){ done();
         if(!c.item_count){ close_(); window.__cdCart=null; stateSync();
           if(window.__sbarApply) window.__sbarApply(); return }
         open_(fromCart(c)) })
       .catch(function(){ done(); location.href='/cart' }) }
   /* クーポンの1行。お会計へはコードを引き継ぐ（打ち直さなくていい。実測で適用される）。
      ただし「初めてのご購入」かどうかはページ側では分からないので、金額の条件だけで
      出し分け、対象者を必ず添える。言い切らない */
   function cpLine(){
     var cpel=$('cd-cp'), sum=$('cd-sum'), totl=$('cd-totl'), tot=$('cd-total'), d=DATA;
     if(!cpel) return;
     var cp=d?coupon():null;
     /* Paidyの月額も、画面でいちばん大きく出ている額に合わせる（食い違うと不信になる） */
     function paidy(v){
       if(typeof window.paidyShow==='function') window.paidyShow('paidy-cd', yen(v)) }
     /* 値引きの段を積む。rows が空なら段をたたんで「合計」1行に戻す。
        一番大きい数字が引いたあとになるので「効いている」が一目で分かる */
     function draw(head,rows,pay){
       if(!sum||!totl||!tot||!d) return;
       if(!rows.length){
         sum.hidden=true; sum.innerHTML='';
         totl.textContent='合計'; tot.textContent=yen(d.total); paidy(d.total); return }
       sum.innerHTML=(head?'<span class="r"><span>小計</span><b>'+yen(head)+'</b></span>':'')+
         rows.map(function(r){
           return '<span class="r r--'+r.cls+'"><span><i class="'+r.chipCls+'">'+esc(r.chip)+'</i>'+
             esc(r.label)+'</span><b>−'+yen(r.off)+'</b></span>' }).join('');
       sum.hidden=false; totl.textContent='お支払い'; tot.textContent=yen(pay); paidy(pay) }

     var sub=d?(d.sub||d.total):0, pay=d?d.total:0, rows=[], note='';
     /* ① セール。通常価格の合計と、いまの小計の差。ラベルは固定文字でよい（きえ確認） */
     var wasSub=d?(d.wasSub||0):0, sOff=(d&&saleOn()&&wasSub>sub)?(wasSub-sub):0;
     if(sOff) rows.push({cls:'sale',chipCls:'saleon',chip:'SALE',label:'期間限定セール',off:sOff});
     /* ② クーポン。
        ★本体が入っていないカートには、このクーポンの話を出さない。
          対象はソファ本体なので、オプションをいくら足しても使えるようにならない。
          金額だけで「あと ¥X で」を出すと、足せば使えると誤解させる（2026/10/06 きえ指摘）
        ★「初めてのご購入」かどうかはページ側では分からないので、金額の条件だけで
          出し分け、対象者を必ず添える。言い切らない */
     var hasBody=false, its=d?(d.items||[]):[], bi;
     for(bi=0;bi<its.length;bi++) if(its[bi].body){ hasBody=true; break }
     if(cp && hasBody){
       if(d.disc>0){
         /* カートにもう割引が乗っている（お会計から戻ってきたときなど）。二重に引かない */
         rows.push({cls:'cp',chipCls:'cpon',chip:'✓ クーポン',label:cp.code,off:d.disc});
         pay=d.total; note='クーポンが適用されています' }
       else if(cp.amount>0 && sub>=cp.min){
         rows.push({cls:'cp',chipCls:'cpon',chip:'✓ クーポン',label:cp.code,off:cp.amount});
         pay=sub-cp.amount; note='レジで自動的に適用されます<span> ／ 初めてのご購入の方</span>' }
       else if(cp.amount>0 && cp.min>sub){
         note='あと <b>'+yen(cp.min-sub)+'</b> で '+yen(cp.amount)+' OFF'+
           '<span> ／ 初めてのご購入の方</span>' }
       else {
         note='クーポン <b>'+esc(cp.code)+'</b> はお会計で自動入力されます' }
     }
     /* 値引きが2つ並ぶときだけ、合わせていくら安いのかを添える */
     if(rows.length>1){
       var tOff=0; rows.forEach(function(r){ tOff+=r.off });
       note='合わせて <b>'+yen(tOff)+'</b> おトク<br>'+note }
     cpel.innerHTML=note; cpel.hidden=!note;
     /* 小計の行。
        ・セール中 … 行そのものが通常価格なので、1品なら同じ数字が2回出るだけ。出さない。
                     2品以上は足し算が見えないので出す（中身は行に出ている額の合計＝通常価格）
        ・セール中でない … 今までどおり小計を出す */
     draw(sOff ? (its.length>1 ? wasSub : 0) : sub, rows, pay) }
   /* お会計のURL。クーポンが出ているあいだはコードを引き継ぐ。
      ★押した瞬間に作り直す。開いたまま掲出期間が終わったときに、
        終わったコードを持ってお会計へ行かせないため */
   function goHref(){ if(!LIVE) return '#';
     var cp=coupon();
     return '/checkout'+(cp&&cp.code?'?discount='+encodeURIComponent(cp.code):'') }
   /* 行に出す金額。セール中なら通常価格、それ以外は今までどおり払う額 */
   function lineYen(it){ return (saleOn() && it.was>it.price) ? it.was : it.price }
   function lineUnit(it){ return (saleOn() && it.unitWas>it.unit) ? it.unitWas : it.unit }
   function open_(d){
     var w=$('cd'), box=$('cd-items'); if(!w||!box) return false;
     var rows=(d&&d.items)||[]; if(!rows.length) return false;
     DATA=d;
     /* 発送予定日。
        ・商品（handle）が2種類以上 … 別々に発送されるので、帯は案内にして品目ごとに出す
        ・1種類でも日付が2つ以上 … 納期はバリアント（SKU）単位のメタフィールドなので、
          同じ商品でも構成によって違うことがある（実測：60商品中8商品で違う）。
          片方の日付だけ出すと嘘になるので、品目ごとに出して
          「遅い方に合わせてまとめてお届け」と書く（テーマのカートと同じ扱い）
        ・日付が1つだけ … その日付を1回だけ出す */
     var hs=rows.map(function(r){return r.handle}).filter(Boolean);
     var uh=hs.filter(function(h,i){return hs.indexOf(h)===i});
     var ds=rows.map(function(r){return r.date}).filter(Boolean);
     var ud=ds.filter(function(x,i){return ds.indexOf(x)===i});
     var mixShip=uh.length>1, mixDate=ud.length>1;
     var multi=mixShip||mixDate, one=ud.length?ud[0]:'';
     box.innerHTML=rows.map(function(it){
       return '<li>'+
         (it.img?'<img loading="lazy" decoding="async" class="th" src="'+esc(thumb(it.img))+'" alt="">'
                :'<span class="th"></span>')+
         '<span class="mn"><b>'+esc(it.name)+'</b>'+
         (it.opt?'<span>'+esc(it.opt)+'</span>':'')+
         (multi&&it.date?'<span>発送予定日 '+esc(it.date)+'</span>':'')+'</span>'+
         /* セール中は、行に通常価格を出す。ここをセール後の金額にすると、
            下で引き算しても同じ数字に戻ってきて「引いたこと」が伝わらない
            （2026/10/09 きえ指摘）。合計は下の「お支払い」が持つ */
         '<span class="pr"><em>'+yen(lineYen(it))+'</em>'+
         (it.qty>1?'<small>'+yen(lineUnit(it))+' × '+it.qty+'</small>':'')+'</span>'+
         '<span class="qt"><span class="cdq">'+
           '<button type="button" data-cdq="-1" data-k="'+esc(it.key)+'"'+
             ' aria-label="数量を1つ減らす"'+(it.qty<2?' disabled':'')+'>−</button>'+
           '<b>'+it.qty+'</b>'+
           '<button type="button" data-cdq="1" data-k="'+esc(it.key)+'" aria-label="数量を1つ増やす">＋</button>'+
         '</span><button type="button" class="cdrm" data-cdrm="1" data-k="'+esc(it.key)+'">削除</button></span>'+
         '</li>'}).join('');
     var sh=$('cd-ship'), shn=$('cd-shipn');
     if(sh){ var b2=sh.querySelector('b');
       sh.classList.toggle('lng',multi);
       if(mixShip){ sh.hidden=false; if(b2) b2.textContent='各商品の納期にあわせて発送' }
       else if(mixDate){ sh.hidden=false; if(b2) b2.textContent='遅い方に合わせてまとめてお届け' }
       else if(one){ sh.hidden=false; if(b2) b2.textContent=one }
       else sh.hidden=true }
     if(shn) shn.hidden=!multi;
     /* 保証はソファ本体が入っているときだけ。オプション（替えカバー・防水・ビーズ）
        だけのカートでは対象にならないので出さない */
     var hasBody=rows.some(function(r){return r.body});
     var incl=$('cd-incl'); if(incl) incl.hidden=!hasBody;
     if(!hasBody) termShow(null);
     /* 条件の文面が無いLPでは、そのバッジ自体を出さない（押しても何も出ないのを防ぐ） */
     var tb=document.querySelectorAll('[data-cdterm]');
     for(var ti=0;ti<tb.length;ti++){
       var li=tb[ti].parentNode;
       if(li) li.hidden=!termHTML(tb[ti].getAttribute('data-cdterm')) }
     /* 「追加中…」のままなら元の文言に戻す */
     var ab=$('c-btn');
     if(ab&&ab.textContent.indexOf('追加中')>=0&&ab.getAttribute('data-cdlabel'))
       ab.textContent=ab.getAttribute('data-cdlabel');
     $('cd-total').textContent=yen(d.total);
     if(typeof window.paidyShow==='function') window.paidyShow('paidy-cd', yen(d.total));
     cpLine();
     var go=$('cd-go');
     if(go) go.setAttribute('href', goHref());
     termShow(null);
     document.body.classList.add('cd-on');
     if(go) try{ go.focus() }catch(e){}
     KEEP=false;
     window.__cdCart={n:d.count||rows.length, total:d.total,
       ids:rows.map(function(r){return String(r.id||'')}).filter(Boolean)};
     stateSync();
     return true }
   function close_(){ document.body.classList.remove('cd-on'); termShow(null); stateSync() }
   /* ── いまカートに入っているものを、LPの上でも齟齬なく出す ──────────
      ドロワーを閉じたあと「もう入っているのに、また入れてしまいそう」になるのを防ぐ。
      触るのは3か所だけ：カート欄の状態帯／カートに入れるボタンの文言／追従バー。
      どれも「カートが空でないとき」しか書き換えない（空ならLP本体の表示のまま） */
   function selIds(){
     /* いま選んでいる中身は、LPが #c-sku に組み立てている add.js のJSONから読む
        （どのLPでも同じ形で入っている。cart-track.js も同じ読み方をしていた） */
     var el=$('c-sku'); if(!el) return [];
     var t=el.textContent||'', i=t.indexOf('add.js ');
     if(i<0) return [];
     try{ var p=JSON.parse(t.slice(i+7));
       return (p.items||[]).map(function(x){return String(x.id)}) }catch(e){ return [] } }
   function stateEl(){
     var el=$('cd-state'); if(el) return el;
     var b=$('c-btn'); if(!b||!b.parentNode) return null;
     el=document.createElement('div');
     el.className='cdstate'; el.id='cd-state'; el.hidden=true;
     /* 行の名前に .s を使わない。LP本体の節の根っこが .s で、
        padding:28px 16px 6px を持っているため、上だけ余白が広い枠になる（実際になった） */
     el.innerHTML='<p class="ln"><span class="lab">'+
       '<span class="ck" aria-hidden="true"></span><b class="n"></b></span><em></em></p>';
     b.parentNode.insertBefore(el,b);
     return el }
   /* カートの中身に戻る。数量の変更・削除・レジへ進むはすべてドロワーの中でできるので、
      行き先は /cart ページではなくドロワー。
      ★レジ（チェックアウト）へ行くと追加も削除もできなくなるので、
        すでに入っているときは「追加」ではなくここへ戻す */
   function openCart(){
     if(!LIVE){ if(DATA) open_(DATA); return }
     fetch('/cart.js',{headers:{'Accept':'application/json'}})
       .then(function(r){ return r.ok?r.json():null })
       .then(function(c){
         /* 別のタブで空にされたあとなど、開けるものが無いときは
            「追加できる状態」に戻すだけ。ここで /cart へ飛ばさない */
         if(!c||!c.item_count){ window.__cdCart=null; DATA=null; KEEP=false; stateSync(); return }
         open_(fromCart(c)) })
       .catch(function(){ location.href='/cart' }) }
   function barSync(){
     var sb=$('sbar'); if(!sb) return;
     var t=sb.querySelector('.t'), a=sb.querySelector('a'); if(!t||!a) return;
     var c=window.__cdCart;
     /* 安心の帯（calm）と非表示のときは触らない。購入の帯だけ、カートの中身に合わせる */
     if(!c||!c.n||sb.hidden||sb.classList.contains('calm')){
       if(sb.getAttribute('data-cdbar')==='1'){ sb.removeAttribute('data-cdbar');
         if(typeof window.__sbarApply==='function') window.__sbarApply() }
       return }
     /* 「送料無料」の位置に戻り道を置く（行を増やさない＝帯の高さが変わらない）。
        送料無料はカート欄の合計の下とドロワーに出ている */
     var html='<b>カートに'+c.n+'点</b>'+yen(c.total)+
       ' ／ <button type="button" class="cdback" data-cdback="1">カートに戻る</button>';
     if(t.innerHTML!==html) t.innerHTML=html;
     if(a.textContent!=='レジに進む') a.textContent='レジに進む';
     var h=goHref(); if(a.getAttribute('href')!==h) a.setAttribute('href',h);
     a.onclick=null;
     sb.setAttribute('data-cdbar','1') }
   function stateSync(){
     var c=window.__cdCart, el=stateEl(), b=$('c-btn');
     if(el){
       if(!c||!c.n) el.hidden=true;
       else{ el.hidden=false;
         el.querySelector('.n').textContent='カートに'+c.n+'点 入っています';
         el.querySelector('em').textContent=yen(c.total) } }
     if(b){
       /* カートに何か入っているあいだは、押しても増えるだけなので「追加」をやめて
          カート（＝ドロワー）へ戻す。**「買い物を続ける」を押したときだけ**
          追加できる状態に戻す（✕や背景で閉じたときは戻り道のまま。
          ボタンの名前と動きを一致させるため） */
       if(b.textContent.indexOf('カートに戻る')<0&&b.textContent.indexOf('追加中')<0)
         b.__cdnat=b.textContent;
       BACK=!!(c&&c.n)&&!KEEP;
       var want=BACK?'カートに戻る　→':(b.__cdnat||'カートに入れる　→');
       if(b.textContent.indexOf('追加中')<0&&b.textContent!==want) b.textContent=want;
       /* ★文言だけ変えても、押せないままだと意味がない。
          「カートに戻る」はサイズも色も選んでいなくても押せる必要がある。
          b.__cdoff は renderSum が付ける「選択が未完成」の印 */
       if(b.textContent.indexOf('追加中')<0)
         b.setAttribute('aria-disabled', (BACK || !b.__cdoff) ? 'false' : 'true'); }
     if(typeof window.__sbarSync==='function') window.__sbarSync();
     barSync(); barLater() }
   /* 選択を描き直したあとに外から呼ぶ（renderSum が文言と状態を上書きするため） */
   window.__cdSync=stateSync;
   /* LPが選択を描き直すたびに #c-sku が変わる。その直後に文言を合わせ直す */
   (function watchSel(){
     var sku=$('c-sku'); if(!sku||typeof MutationObserver!=='function') return;
     var t=null;
     new MutationObserver(function(){ clearTimeout(t); t=setTimeout(stateSync,0) })
       .observe(sku,{childList:true,characterData:true,subtree:true}) })();
   /* スクロールのたびに見直す。★LP本体の追従バー処理より「あと」に書きたいので
      requestAnimationFrame を通す（同じ scroll イベントの中だと、登録順によって
      こちらの文言が上書きされる。特等席LPで実際に上書きされた） */
   var barPend=0;
   function barRun(){ barPend=0; barSync() }
   function barLater(){ if(barPend) return; barPend=1;
     /* 裏に回ったタブでは requestAnimationFrame が動かない。両方仕掛ける
        （barSync は同じ内容なら書かないので、2回走っても無害） */
     if(window.requestAnimationFrame) window.requestAnimationFrame(barRun);
     setTimeout(barRun,0) }
   window.addEventListener('scroll',barLater,{passive:true});
   window.addEventListener('resize',barLater);
   /* 読み込み直後：すでにカートに入っているものがあれば、その状態から始める
      （戻ってきた人・読み込み直した人に「空のLP」を見せない） */
   if(LIVE) setTimeout(function(){
     fetch('/cart.js',{headers:{'Accept':'application/json'}})
       .then(function(r){ return r.ok?r.json():null })
       .then(function(c){ if(!c||!c.item_count) return;
         var d=fromCart(c);
         window.__cdCart={n:d.count,total:d.total,
           ids:d.items.map(function(r){return String(r.id||'')}).filter(Boolean)};
         DATA=d; stateSync() })
       .catch(function(){}) },0);
   /* 「カートに入れる」ボタンの文言を押す前に控える。移植先のLPでは
      ドロワーを開いたあとに「追加中…」のまま残ることがあるので、開くときに戻す */
   document.addEventListener('click',function(e){
     var t=e.target&&e.target.closest?e.target.closest('[data-cdback]'):null;
     if(t){ e.preventDefault(); e.stopPropagation(); openCart(); return }
     var b=e.target&&e.target.closest?e.target.closest('#c-btn'):null;
     if(!b) return;
     if(b.textContent.indexOf('追加中')<0&&b.textContent.indexOf('カートに戻る')<0)
       b.setAttribute('data-cdlabel',b.textContent);
     /* 戻り道になっているときは、LP本体の「カートに入れる」処理を止めてカートを開く。
        capture で拾うので LP側のクリック処理には届かない */
     if(BACK&&ON){ e.preventDefault(); e.stopImmediatePropagation(); openCart() }
   },true);
   /* 押す直前にURLを作り直す。掲出が終わっていればコードは付かない */
   var goA=$('cd-go');
   if(goA) goA.addEventListener('click',function(){ goA.setAttribute('href', goHref()) });
   var bara=document.querySelector('#sbar a');
   if(bara) bara.addEventListener('click',function(){
     if((bara.getAttribute('href')||'').indexOf('/checkout')===0) bara.setAttribute('href', goHref()) });
   /* 開いたまま掲出期間をまたいでも表示が残らないように、30秒ごとと
      タブに戻った瞬間に見直す（クーポンのセクション自身と同じ間隔） */
   setInterval(function(){ if(document.body.classList.contains('cd-on')) cpLine() },30000);
   document.addEventListener('visibilitychange',function(){
     if(!document.hidden && document.body.classList.contains('cd-on')) cpLine() });
   ['cd-x','cd-bg','cd-more'].forEach(function(id){
     var e=$(id); if(e) e.addEventListener('click',function(ev){ ev.preventDefault();
       if(id==='cd-more') KEEP=true;      /* 続けて選びたい＝また追加できる状態に戻す */
       close_() })});
   var root=$('cd');
   if(root) root.addEventListener('click',function(e){
     var t=e.target&&e.target.closest?e.target.closest('[data-cdq],[data-cdrm],[data-cdterm],[data-cdterm-close]'):null;
     if(!t) return;
     e.preventDefault();
     if(t.hasAttribute('data-cdterm-close')){ termShow(null); return }
     if(t.hasAttribute('data-cdterm')){ termShow(t.getAttribute('data-cdterm')); return }
     var k=t.getAttribute('data-k'); if(!k) return;
     if(t.hasAttribute('data-cdrm')){ change(k,0); return }
     var n=t.parentNode.querySelector('b');
     var now=n?(parseInt(n.textContent,10)||1):1;
     change(k, Math.max(0, now+(parseInt(t.getAttribute('data-cdq'),10)||0)));
   });
   document.addEventListener('keydown',function(e){
     if(e.key==='Escape'&&document.body.classList.contains('cd-on')) close_() });
   /* 外から使う口 */
   window.__cdOn=ON;
   window.__cdCart=null;
   window.__cdGoHref=goHref;
   window.__cdAfterAdd=function(){
     return fetch('/cart.js',{headers:{'Accept':'application/json'}})
       .then(function(r){ if(!r.ok) throw 0; return r.json() })
       .then(function(c){ return open_(fromCart(c)) }) };
   window.__cdOpenLocal=function(list,img){ return open_(fromLocal(list,img)) };
 })();
 /*CDJS:END*/

 function renderSum(){
   var v=curV(),sel=$('c-sel'),pz=$('c-price'),sku=$('c-sku'),b=$('c-btn');
   if(!st.s){sel.textContent='サイズを選んでください'}
   else if(!st.c){sel.textContent=st.s+' ／ カラーを選んでください'}
   else if(!v){sel.textContent=st.s+' ／ '+st.c+' ／ セットを選んでください'}
   var incl=$('c-incl');
   var cond=$('c-cond');
   var cush=$('c-cush'); if(cush) cush.hidden=!(v&&v[1].indexOf('クッションカバー')>=0);
   if(!v){pz.innerHTML='—';sku.textContent='';incl.hidden=true;if(cond)cond.hidden=true;
     paidyShow('paidy-cart', null);
     var sh0=$('c-ship'); if(sh0) sh0.hidden=true;
     b.__cdoff=true;                       /* 選択が未完成＝本来は押せない */
     b.setAttribute('aria-disabled','true');b.href='#';
     b.textContent='カートに入れる　→';
     /* カートに中身があれば「カートに戻る」に戻してもらう。ここで決め打ちしない */
     if(typeof window.__cdSync==='function') window.__cdSync();
     sbarPick(null);return}
   incl.hidden=false; if(cond)cond.hidden=false;
   var list=items(),total=0,wasTotal=0;
   /* 通常価格の入っていない品は、通常価格＝販売価格として足す。
      そうしないと、オプションを足すたびに「引いた額」が増えてしまう */
   list.forEach(function(x){total+=x[2]; wasTotal+=(x[4]&&x[4]>x[2])?x[4]:x[2]});
   shipSync(v,list);
   sbarPick(v,list);
   sel.innerHTML=list.map(function(x,i){return (i?'＋ ':'')+x[1]}).join('<br>');
   /* セール中は 通常価格（打ち消し）→ 引いた額 → 販売価格 の順。
      合計を出すのはカートの欄だけ（docs/rules.md 価格の粒度）。ここが唯一の合計 */
   pz.innerHTML=saleTotalHTML(total,wasTotal,
     '<small>税込・送料無料'+(list.length>1?' ／ '+list.length+'点':'')+'</small>');
   paidyShow('paidy-cart', yen(total));
   var perm=list.map(function(x){return x[0]+':1'}).join(',');
   sku.textContent='/cart/'+perm+'　／　POST /cart/add.js {"items":['+list.map(function(x){return '{"id":'+x[0]+',"quantity":1'+(x[3]?',"properties":{"発送予定日":"'+x[3]+'"}':'')+'}'}).join(',')+']}';
   b.__cdoff=false;
   b.setAttribute('aria-disabled','false');b.href='https://littlerooms.jp/cart/'+perm;
   b.textContent=(list.length>1?list.length+'点をカートに入れる':'カートに入れる')+'　→';
   /* カート投入は POST /cart/add.js を通す。
      理由は計測。/cart/<id>:1 のパーマリンクはサーバ側でカートを作って /cart へ
      リダイレクトするだけなので、Shopifyのウェブピクセル（Meta／GA4）の
      product_added_to_cart が一度も発火しない＝AddToCartが取れない。
      Ajax カートAPI なら Shopify 自身が発火させるので、content_ids も
      カタログと同じ形式で飛ぶ（自前で fbq を叩くとIDの形式を推測することになる）。
      失敗したときは従来のパーマリンクへ落とすので、最悪でも今までと同じ動きになる。 */
   if(!b.__wired){ b.__wired=1;
     b.addEventListener('click',function(e){
       if(b.getAttribute('aria-disabled')==='true'){ e.preventDefault(); return; }
       if(location.hostname.indexOf('littlerooms')<0){ e.preventDefault();  /* モックは見た目だけ */
         var pvi0=document.getElementById('pv-img');
         window.__cdOpenLocal(items(), pvi0?pvi0.getAttribute('src'):''); return; }
       var cur=items(); if(!cur.length) return;
       e.preventDefault();
       if(b.__busy) return;                                 /* 連打で二重に入れない */
       var back=b.getAttribute('href');
       b.__busy=1;
       var t0=b.textContent; b.textContent='追加中…';
       /* 入ったあとは /cart へ、入る前なら permalink へ。入ったのに permalink へ戻すと
          もう1点入ってしまうので、ここは必ず added で分ける */
       var added=false;
       var to=setTimeout(function(){ location.href=added?'/cart':back; },6000);   /* 応答が無いとき */
       fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
         body:JSON.stringify({items:cur.map(function(x){
           var o={id:x[0],quantity:1};
           /* 通常導線（商品ページの custom-variant-delivery-date.liquid）と同じ形。
              これが無いとカート・注文に発送予定日が残らない */
           if(x[3]) o.properties={'発送予定日':x[3]};
           return o})})})
         .then(function(r){ if(!r.ok) throw 0; added=true; clearTimeout(to);
           /* ドロワーを出さない設定のときは、これまでどおり /cart へ */
           if(!window.__cdOn){ location.href='/cart'; return null }
           return window.__cdAfterAdd() })                 /* 中身はカート全体から出す */
         .then(function(ok){ if(ok===null) return;         /* 遷移済み */
           b.__busy=0; b.textContent=t0;
           if(!ok) location.href='/cart'; })
         .catch(function(){ clearTimeout(to); b.__busy=0; b.textContent=t0;
           location.href = added ? '/cart' : back; });
     });
   }}

 function renderPick(){
   var el=$('c-pick'); if(!el) return;
   /* 貼りつくバーに一本化したため通常は要素なし */
   if(st.s&&st.c){
     // 上のプレビューと同じ写真。#pv-img を先に見て、無ければ色見本に落とす
     var pvi=document.getElementById('pv-img');
     var im=(pvi&&pvi.getAttribute('src'))?pvi:document.getElementById(key(st.c));
     var v=curV();
     el.className='cbhead cbsel';
     /* セットまで決まったら、ここにも発送予定日を出す。出典はカート下と同じ
        バリアントメタフィールド custom.delivery_date。出すのはソファ本体の分だけ */
     var dv=(v&&v[4])?String(v[4]).replace(/[<>&]/g,''):'';
     el.innerHTML=(im?'<img src="'+im.getAttribute('src')+'" alt="'+st.c+'">':'')+
       '<span class="t"><b>'+st.c+'</b><span>'+st.s+(v?' ／ '+v[1]:'')+'</span>'+
       '<a class="tlink" id="c-repick" href="#chips">選び直す</a></span>'+
       '<em style="font-style:normal;font-weight:700;font-size:15px">'+(v?yen(v[2]):'')+'</em>'+
       (dv?'<span class="d"><span>発送予定日</span><b>'+dv+'</b></span>':'');
     return;
   }
   el.className='cbhead';
   if(st.s){
     el.innerHTML='<b>'+st.s+'</b> を選択中。<a class="tlink" href="#s8">上で色を選ぶ</a>と、構成を決めてカートに入れられます。';
   }else{
     el.innerHTML='まず上で<a class="tlink" href="#s8">サイズと色を選ぶ</a>と、ここで構成を決めてカートに入れられます。';
   }
 }
 function render(){renderSize();renderColor();renderType();renderAdd();renderSum();renderPick()}
 // サイズ・カラーは S8 のピッカーが唯一の選択場所。ここはその状態を受け取るだけ。
 window.__cartSync=function(size,color){
   st.s=size||null; st.c=color||null; st.t=null; st.add={}; st.covc=null; st.covopen=false;
   applyWant(); applyPend();
   render();
 };
 // S11 の道具カードから「一緒に買う」を選んだ状態でカートへ戻す
 var WANT=null;
 function applyWant(){
   if(!WANT) return;
   var p=cur(); if(!p) return;
   var kw=(WANT==='otto')?'オットマン':'クッションカバー';
   for(var i=0;i<p.v.length;i++){
     if(p.v[i][1].indexOf(kw)>=0 && p.v[i][3]!==0){ st.t=p.v[i][0]; WANT=null; return; }
   }
 }
 // 色より先に「一緒に買う」を選んだ場合も意図を覚えておき、色が決まった時点で反映する
 var PEND={};
 function ensureType(){
   // 「いっしょに買う」は構成が決まらないと出せないので、未選択なら最安（ソファ単品）を入れておく
   if(st.t||!st.c) return;
   var p=cur(); if(!p) return;
   var best=null;
   p.v.forEach(function(x){ if(x[3]!==0 && (!best||x[2]<best[2])) best=x; });
   if(best) st.t=best[0];
 }
 function applyPend(){
   if(!st.c) return;
   var any=false;
   for(var k in PEND){ if(PEND[k]) any=true; }
   if(!any) return;
   ensureType();
   if(PEND.beads) st.add.beads=true;
   if(PEND.wp) st.add.wp=true;
   if(PEND.cov){
     st.add.cov=true;
     if(!st.covc){ var covs=covList();
       for(var i=0;i<covs.length;i++){ if(covs[i][0]===st.c){ st.covc=covs[i][0]; break; } }
       if(!st.covc&&covs.length) st.covc=covs[0][0];
     }
   }
 }
 window.__cartAdd=function(kind){
   if(kind==='otto'||kind==='cus'){ WANT=kind; applyWant(); }
   else { PEND[kind]=true; applyPend(); }
   render();
   var aw=document.getElementById('c-addwrap');
   if(aw && kind!=='otto' && kind!=='cus') aw.open=true;
   scrollToCart();
 };
 function scrollToCart(){
   var sec=document.getElementById('cartblock'); if(!sec||sec.hidden) sec=document.getElementById('s8');
   if(!sec) return;
   setTimeout(function(){
     var y=sec.getBoundingClientRect().top+window.pageYOffset-8;
     window.scrollTo({top:y,behavior:document.hidden?'auto':'smooth'});
   },0);
 }
 window.__cartPick=function(size,color){
   /* すでに同じサイズ・色を選んでいるなら作り直さない。
      __cartSync は「選び直し」用で、構成とオプション（st.t / st.add / st.covc）を消す。
      これが原因で、オプションを選んだあと追従バーから飛ぶと外れていた */
   if(st.s!==size||st.c!==color) window.__cartSync(size,color);
   scrollToCart();
 };
 // 価格は必ずCARTから出す。静的テキストで持つと、値上げのたびに直し漏れる
 function fillPrices(){
   var wp={};
   CART.p.forEach(function(p){ if(p.wp && !wp[p.s]) wp[p.s]=p.wp[1]; });
   var V={beads:(CART.beads?CART.beads[1]:null), wp1:wp['1人掛け'], wp2:wp['2人掛け']};
   /* ★ここ（補充ビーズ・防水インナーカバー・スペック表）はセールを反映しない。
      「こういう商品があります」の紹介であって、買う画面ではないため（2026/10/09 きえ判断）。
      打ち消しとオフ率を出すのは、買う判断をする場所だけ＝
      追従バー／商品カード／セット選択チップ／カートの合計／カートのドロワー */
   Array.prototype.forEach.call(document.querySelectorAll('[data-price]'),function(el){
     var v=V[el.getAttribute('data-price')];
     // 値が取れないときは空にする。古い金額を出すより出さないほうがまし
     if(v==null){ el.textContent=''; return; }
     el.textContent=yen(v)+(el.hasAttribute('data-notax')?'':'（税込）');
   });
 }
 fillPrices();

 /* 選択状態を sessionStorage に覚えておく。
    規約・生地サンプル・ARなどのリンクを同一タブで開くようにしたので、
    戻ってきたときに bfcache が効かないと選択が消える。
    サイズ・カラー・構成・追加品だけを持ち、同じタブを閉じれば消える。
    個人情報は入れない（商品の選択内容のみ）。 */
 var SKEY='loosy-lp-pick';
 function saveState(){
   try{ sessionStorage.setItem(SKEY, JSON.stringify({s:st.s,c:st.c,t:st.t,add:st.add,covc:st.covc})); }catch(e){}
 }
 function loadState(){
   var o=null;
   try{ var raw=sessionStorage.getItem(SKEY); if(raw) o=JSON.parse(raw); }catch(e){}
   if(!o||!o.s) return;
   // 実在する組み合わせのときだけ戻す。商品が入れ替わっていたら黙って捨てる
   if(!CART.p.some(function(p){ return p.s===o.s && (!o.c || p.c===o.c); })) return;
   // S8のピッカーはこの後に初期化され、そこで __cartSync(size,null) が走って
   // 色が消える。だから直接 st を書かず、ピッカーが立ち上がったあとに
   // 本来の操作と同じ経路（タブ→チップ）でなぞる
   var run=function(){
     var tabs=[].slice.call(document.querySelectorAll('#s8 .tabs span'));
     var tab=tabs.filter(function(x){ return x.textContent.indexOf(o.s)===0; })[0];
     if(tab && !tab.classList.contains('on')) tab.click();
     if(o.c){
       // 復元でViewContentを二重に出さない
       try{ var vid=(CART.p.filter(function(p){return p.s===o.s&&p.c===o.c})[0]||{}).v[0][0];
            window.__vcSent=window.__vcSent||{}; window.__vcSent[vid]=1; }catch(e){}
       var chip=document.querySelector('#chips button[data-c="'+o.c.replace(/"/g,'')+'"]');
       if(chip) chip.click();
     }
     /* 前に選んでいた構成が在庫切れになっていたら戻さない */
     if(o.t){ var pp=CART.p.filter(function(p){return p.s===o.s&&p.c===o.c})[0];
       var vv=pp&&pp.v.filter(function(v){return v[0]===o.t})[0];
       if(vv && vv[3]!==0) st.t=o.t; }
     if(o.add) st.add=o.add;
     if(o.covc) st.covc=o.covc;
     render();
   };
   if(document.readyState==='complete') setTimeout(run,0);
   else window.addEventListener('load',function(){ setTimeout(run,0); });
 }
 var _render=render;
 render=function(){ _render(); saveState(); };

 loadState();
 render();
})();

/* AR動画。preload="none" にしてあるので、ここで初めて読み込みが始まる。
   FVと帯域を奪い合わせないための遅延。読み込めなくてもポスター画像が残る */
(function(){
  var v=document.querySelector('video.shot--video');
  if(!v) return;
  var started=false;
  function go(){
    if(started) return; started=true;
    /* autoplay を今つける。JSの play() が弾かれる環境でも、
       ブラウザ本来の自動再生（muted+playsinline は許可される）に乗る */
    v.setAttribute('autoplay','');
    var pr=v.play();
    if(pr && pr.catch) pr.catch(function(){});
  }
  if(!('IntersectionObserver' in window)){ go(); return; }
  var io=new IntersectionObserver(function(es){
    for(var i=0;i<es.length;i++){
      if(es[i].isIntersecting){ go(); io.disconnect(); return; }
    }
  },{rootMargin:'300px 0px'});
  io.observe(v);
})();
